export const az = {
  sidebar: {
    dashboard: 'İdarə paneli',
    themeLabel: 'Rəng',
    themeChange: 'Menyunun rəngi',
    theme_firuzeyi: 'Firuzəyi',
    theme_gece: 'Gecə',
    theme_sherab: 'Şərab',
    theme_mese: 'Meşə',
    theme_komur: 'Kömür',
    theme_benovseyi: 'Bənövşəyi',
    theme_buz: 'Buz',
    theme_sedef: 'Sədəf',
    patternLabel: 'Naxış',
    patternNone: 'Naxışsız',
    patternGrid: 'Tor',
    patternDots: 'Nöqtə',
    viewLabel: 'Görünüş',
    viewList: 'Siyahı',
    viewGrid: 'Şəbəkə',
    students: 'Tələbələr',
    teachers: 'Müəllimlər',
    classes: 'Siniflər',
    subjects: 'Fənlər',
    attendance: 'Davamiyyət',
    grades: 'Qiymətlər',
    timetableBuilder: 'Cədvəl Tərtibçisi',
    announcements: 'Elanlar',
    requests: 'Şöbələr',
    enrollment: 'Şagird qeydiyyatı',
    users: 'İstifadəçilər',
    procurement: 'Təchizat',
    leave: 'İcazələr',
    analytics: 'Analitika',
    menuSetup: 'Menyu quraşdırması',
    warehouse: 'Anbar',
    groupMain: 'Əsas',
    groupAcademic: 'Akademik',
    groupAdmission: 'Şagird qeydiyyatı üzrə qəbul şöbəsi',
    groupComm: 'Ünsiyyət',
    groupSystem: 'Sistem',
  },
  topbar: {
    title: 'Elektron Məktəb Sistemi',
    messages: 'Mesajlar',
    myRequests: 'Mənim sorğularım',
    notifications: 'Bildirişlər',
    readAll: 'Hamısını oxu',
    noNotifications: 'Yeni bildiriş yoxdur',
    newRequestsWaiting: 'yeni sorğu gözləyir',
    admissionWaiting: 'qəbul müraciəti gözləyir',
    studentSignWaiting: 'şagird imza gözləyir',
    enrollmentSubmenu: 'Qeydiyyat → Qəbul Müraciətləri',
    enrollmentTable: 'Qeydiyyat Cədvəli',
    logout: 'Çıxış',
    hidePanel: 'Üst paneli gizlət',
    showPanel: 'Üst paneli göstər',
    changePhoto: 'Şəkil dəyiş',
  },
  common: {
    save: 'Yadda saxla',
    cancel: 'İmtina',
    delete: 'Sil',
    edit: 'Redaktə et',
    add: 'Əlavə et',
    addAction: '+ Əlavə et',
    close: 'Bağla',
    search: 'Axtar',
    searchPlaceholder: 'Axtar...',
    filter: 'Filtr',
    clear: 'Təmizlə',
    loading: 'Yüklənir...',
    saving: 'Saxlanılır...',
    noData: 'Məlumat yoxdur',
    confirm: 'Təsdiqlə',
    confirmDelete: 'Silmək istəyirsiniz?',
    yes: 'Bəli',
    no: 'Xeyr',
    ok: 'OK',
    send: 'Göndər',
    back: 'Geri',
    all: 'Hamısı',
    active: 'Aktiv',
    inactive: 'Qeyri-aktiv',
    total: 'Cəmi',
    date: 'Tarix',
    print: 'Çap',
    export: 'İxrac',
    select: 'Seçin',
    error: 'Xəta',
    actions: 'Əməliyyat',
    name: 'Ad',
    fullName: 'Ad Soyad',
    position: 'Vəzifə',
    email: 'Email',
    phone: 'Telefon',
    username: 'İstifadəçi adı',
    password: 'Şifrə',
    address: 'Ünvan',
    status: 'Status',
    result: 'nəticə',
    results: 'nəticə',
    rowNum: '#',
    notFound: 'Tapılmadı',
    deleteConfirm: 'Silmək?',
    fileTooLarge: 'Yükləmə xətası',
    today: 'Bu gün',
  },
  dashboard: {
    welcome: 'Xoş gəlmisiniz',
    students: 'Tələbələr',
    teachers: 'Müəllimlər',
    classes: 'Siniflər',
    subjects: 'Fənlər',
    requests: 'Sorğular',
    openRequests: 'Açıq sorğu',
    todayAttendance: 'Bu günün davamiyyəti',
    presentToday: 'Bu gün iştirak',
    absentToday: 'İştirak etmir',
    present: 'İştirak edir',
    absent: 'İştirak etmir',
    late: 'Gecikir',
    excused: 'Üzrlü',
    people: 'nəfər',
    noAttendanceToday: 'Bu gün davamiyyət qeyd edilməyib',
    monthlyRating: 'Aylıq Reytinq',
    byRating: 'Reytinqə görə',
    byCount: 'Saya görə',
    bySpeed: 'Sürətə görə',
    highestRating: 'Ən yüksək qiymət',
    mostTickets: 'Ən çox tikket',
    fastest: 'Ən sürətli',
    avgRating: 'Ort. qiymət',
    tickets: 'tikket',
    resolved: 'Həll',
    open: 'Açıq',
    closed: 'Bağlı',
    total: 'Cəmi',
    signed: 'İmzalı',
    pending: 'Gözləyən',
    avgPrefix: 'Ort:',
    noRating: 'Qiymət yoxdur',
    loading: 'Yüklənir...',
    noData: 'Məlumat yoxdur',
    requestsTitle: 'Sorğular',
    filterAll: 'Hamısı',
    filterOpen: 'Açıq',
    filterAssigned: 'Təyin',
    filterInProgress: 'İcrada',
    filterResolved: 'Həll',
    filterClosed: 'Bağlı',
    statusOpen: 'Açıq',
    statusAssigned: 'Təyin edildi',
    statusInProgress: 'İcrada',
    statusResolved: 'Həll edildi',
    statusClosed: 'Bağlı',
    noRequestsTitle: 'Sorğu yoxdur',
    menuTitle: 'Günün menyusu',
    menuSchool: 'Məktəb',
    menuKinder: 'Bağça',
    menuUpload: 'Menyu yüklə',
    menuUploading: 'Yüklənir...',
    menuUploaded: 'Menyu yükləndi — {gun} gün, {yemek} yemək',
    menuEmpty: 'Bu gün üçün menyu yoxdur',
    myRequests: 'Mənim sorğularım',
    viewAll: 'Hamısını gör',
    noRequests: 'Hələ heç bir sorğunuz yoxdur',
    announcements: 'Son Elanlar',
    noAnnouncements: 'Elan yoxdur',
    enrollment: 'Qeydiyyat',
    enrollmentPreschool: 'Məktəbəqədər',
    enrollmentPrimary: 'İbtidai',
    enrollmentSecondary: 'Orta',
    pendingAdmissionsCount: 'qəbul müraciəti gözləyir',
    pendingSignaturesCount: 'şagird imza gözləyir',
  },
  students: {
    title: 'Tələbələr',
    titleEmoji: 'Tələbələr',
    countSuffix: 'tələbə',
    btnAdd: '+ Tələbə əlavə et',
    modalNew: 'Yeni Tələbə',
    modalEdit: 'Tələbəni Redaktə et',
    colClass: 'Sinif',
    colFirstName: 'Adı',
    colLastName: 'Soyadı',
    colFatherName: 'Ata adı',
    genderMale: 'Kişi',
    genderFemale: 'Qadın',
    colStudentNumber: 'Şagird №',
    colParent: 'Valideyn',
    colParentPhone: 'Valideyn tel.',
    colGender: 'Cins',
    fieldClass: 'Sinif',
    selectClass: 'Sinif seçin',
    fieldStudentNumber: 'Şagird №',
    fieldParentName: 'Valideyn adı',
    fieldParentPhone: 'Valideyn telefonu',
    fieldBirthDate: 'Doğum tarixi',
    fieldGender: 'Cins',
    fieldAddress: 'Ünvan',
    fieldPasswordHint: 'Şifrə (boş buraxılırsa: school123)',
    fieldPasswordChange: 'Şifrə dəyiş',
    fieldPasswordPlaceholder: 'Dəyişdirmək üçün daxil edin',
    genderBoy: 'Oğlan',
    genderGirl: 'Qız',
    genderBoyEmoji: 'Oğlan',
    genderGirlEmoji: 'Qız',
    confirmDelete: 'Bu tələbəni silmək istədiyinizdən əminsiniz?',
    error: 'Xəta baş verdi',
    emptyMsg: 'Tələbə qeydiyyatı yoxdur',
  },
  teachers: {
    title: 'Müəllimlər',
    titleEmoji: 'Müəllimlər',
    countSuffix: 'müəllim',
    btnAdd: '+ Müəllim əlavə et',
    modalNew: 'Yeni Müəllim',
    modalEdit: 'Müəllimi Redaktə et',
    colSubjects: 'Fənlər',
    fieldHireDate: 'İşə qəbul tarixi',
    fieldSubjects: 'Tədris etdiyi fənlər',
    confirmDelete: 'Bu müəllimi silmək istədiyinizdən əminsiniz?',
    fieldPasswordChange: 'Şifrə dəyiş',
    fieldPasswordPlaceholder: 'Dəyişdirmək üçün',
  },
  classes: {
    title: 'Siniflər',
    studentSuffix: 'şagird',
    studentNumberCol: '№',
    colLastName: 'Soyadı',
    colFirstName: 'Adı',
    colFatherName: 'Ata adı',
    colSignature: 'İmza',
    colPayment: 'Ödəniş',
    colCategory: 'Kateq.',
    capacity: 'Tutum',
    statusOut: 'OUT',
    statusActive: 'Aktiv',
    signed: 'Signed',
    pending: 'Gözləyir',
    paymentDeposit: 'Depozit',
    paymentAnnual: 'İllik',
    paymentDeposit40: 'Dep+40%',
    childStaff: 'Staff',
    childMartyr: 'Şəhid',
    sectionPreschool: 'Pre-school',
    sectionPrimary: 'Primary',
    sectionSecondary: 'Secondary',
    noStudents: 'Bu sinifdə şagird yoxdur',
  },
  subjects: {
    title: 'Fənlər',
    countSuffix: 'fənn',
    btnAdd: '+ Fənn əlavə et',
    modalNew: 'Yeni Fənn',
    modalEdit: 'Fənni Redaktə et',
    fieldName: 'Fənn adı',
    fieldCode: 'Kod',
    codePlaceholder: 'məs: MAT',
  },
  attendance: {
    title: 'Davamiyyət',
    subtitle: 'Sinif üzrə gündəlik davamiyyət qeydiyyatı',
    selectClass: 'Sinif seçin',
    fieldClass: 'Sinif',
    fieldDate: 'Tarix',
    selectAll: 'Hamısını:',
    studentSuffix: 'şagird',
    noStudents: 'Bu sinifdə şagird yoxdur',
    saved: 'Yadda saxlanıldı!',
    btnSave: 'Davamiyyəti Saxla',
    statusPresent: 'İştirak edir',
    statusAbsent: 'İştirak etmir',
    statusLate: 'Gecikir',
    statusExcused: 'Üzrlü',
    overviewTitle: 'Bu günkü davamiyyət (sinif seçməyin və bütün məktəbi görün)',
    overviewEmpty: 'Bu gün üçün heç bir qeyd yoxdur',
    class: 'Sinif',
  },
  grades: {
    title: 'Qiymətlər',
    countSuffix: 'qiymət',
    btnAdd: '+ Qiymət əlavə et',
    modalNew: 'Qiymət əlavə et',
    modalEdit: 'Redaktə et',
    colStudent: 'Şagird',
    colSubject: 'Fənn',
    colType: 'Növ',
    colQuarter: 'Rüb',
    colGrade: 'Qiymət',
    colDate: 'Tarix',
    fieldStudent: 'Şagird',
    fieldSubject: 'Fənn',
    fieldType: 'Növ',
    fieldQuarter: 'Rüb',
    fieldGrade: 'Qiymət',
    fieldDate: 'Tarix',
    quarterSuffix: '. rüb',
    allClasses: 'Bütün siniflər',
    allSubjects: 'Bütün fənlər',
    allQuarters: 'Bütün rüblər',
    typeExam: 'İmtahan',
    typeQuiz: 'Sorğu',
    typeHomework: 'Ev tap.',
    typeProject: 'Layihə',
    typeMidterm: 'Yarımillik',
    typeFinal: 'İllik',
    typeQuarter: 'Rüblük',
  },
  schedule: {
    title: 'Dərs cədvəli',
    selectClass: 'Sinif seçin',
    selectClassPrompt: 'Cədvəl üçün sinif seçin',
    btnAdd: '+ Əlavə et',
    colLesson: 'Dərs',
    fieldSubject: 'Fənn',
    fieldTeacher: 'Müəllim',
    fieldDay: 'Gün',
    fieldLessonNumber: 'Dərs nömrəsi',
    fieldStart: 'Başlama',
    fieldEnd: 'Bitmə',
    fieldRoom: 'Otaq',
    roomPrefix: 'Otaq:',
    btnEditCell: 'Edit',
    btnDeleteCell: 'Sil',
    modalNew: 'Dərs əlavə et',
    modalEdit: 'Dərsi redaktə et',
    lessonSuffix: '. dərs',
  },
  announcements: {
    title: 'Elanlar',
    countSuffix: 'elan',
    btnAdd: '+ Elan əlavə et',
    modalNew: 'Yeni Elan',
    modalEdit: 'Elanı Redaktə et',
    fieldTitle: 'Başlıq',
    fieldText: 'Mətn',
    fieldTarget: 'Hədəf qrup',
    targetAll: 'Hamısı',
    targetStudents: 'Şagirdlər',
    targetTeachers: 'Müəllimlər',
    targetParents: 'Valideynlər',
    roleAll: 'Hamısı',
    roleStudent: 'Şagird',
    roleTeacher: 'Müəllim',
    roleParent: 'Valideyn',
    btnEdit: 'Edit',
    btnDelete: 'Sil',
    empty: 'Elan yoxdur',
  },
  users: {
    fieldManager: 'Birbaşa rəhbər',
    managerHint: 'İşburaxma ərizəsi əvvəlcə bu şəxsə gedir. Boş qalsa, şöbə rəhbərinə gedəcək.',
    managerNone: '— təyin edilməyib —',
    managerSearch: 'Ad və ya vəzifə yazın...',
    needsSetup: 'Yeni — tənzimlənməyib',
    needsSetupHint: 'Microsoft ilə ilk dəfə girib. Rol, vəzifə və menyu icazələri hələ təyin edilməyib.',
    title: 'İstifadəçilər',
    countSuffix: 'istifadəçi',
    btnAdd: '+ İstifadəçi əlavə et',
    modalNew: 'Yeni İstifadəçi',
    modalEdit: 'İstifadəçini Redaktə et',
    colUser: 'İşçi',
    colPositionDept: 'Vəzifə / Şöbə',
    colRole: 'Rol',
    fieldRole: 'Rol *',
    fieldPosition: 'Vəzifə',
    fieldDept: 'Şöbə',
    selectPosition: 'Vəzifə seçin',
    selectDept: 'Şöbə seçin',
    selectAllDepts: 'Bütün şöbələr',
    customPosOption: 'Digər (əl ilə yazın)',
    customPosPlaceholder: 'Vəzifə adını yazın',
    posInputPlaceholder: 'Vəzifə daxil edin',
    searchPlaceholder: 'Ad, username, vəzifə axtar...',
    uploadPhoto: 'Şəkil yüklə',
    uploadHint: 'JPG, PNG, max 5MB',
    permsTitle: 'Menu İcazələri',
    btnEdit: 'Redaktə',
    btnDelete: 'Sil',
    confirmDelete: 'silinsin?',
    error: 'Xəta baş verdi',
    fieldFullName: 'Ad Soyad *',
    fieldUsername: 'Username *',
    fieldPasswordRequired: 'Şifrə *',
    fieldPasswordChange: 'Şifrə dəyiş',
    passwordPlaceholder: 'Boş buraxsan dəyişməz',
    roleAdmin: 'Admin',
    roleAdminDesc: 'Tam sistem girişi',
    roleManagement: 'Rəhbər Heyəti',
    roleManagementDesc: 'Rəhbər heyəti',
    roleStaff: 'İnzibati İşçi',
    roleStaffDesc: 'Daxili işçi',
    roleTeacher: 'Müəllim',
    roleTeacherDesc: 'Tədris heyəti',
    roleStudent: 'Şagird',
    roleStudentDesc: 'Şagird',
    roleParent: 'Valideyn',
    roleParentDesc: 'Valideyn/Qəyyum',
    tabAll: 'Hamısı',
    tabStaff: 'Heyət',
  },
  myRequests: {
    openInDept: 'Şöbədə tam məlumata bax',
    title: 'Mənim sorğularım',
    activeSuffix: 'aktiv',
    totalSuffix: 'cəmi',
    notFound: 'Sorğu tapılmadı',
    searchPlaceholder: 'Axtar (nömrə, başlıq)',
    allStatuses: 'Bütün statuslar',
    allDepts: 'Bütün şöbələr',
    dateFrom: 'Tarixdən',
    dateTo: 'Tarixə qədər',
    tabInfo: 'Məlumat',
    tabComments: 'Şərhlər',
    tabAudit: 'Tarixçə',
    fieldStatus: 'Status',
    fieldDept: 'Şöbə',
    fieldPriority: 'Prioritet',
    fieldRequester: 'Yaradan',
    fieldAssignee: 'Təyin olunmuş',
    fieldDate: 'Tarix',
    fieldResolvedAt: 'Həll tarixi',
    fieldTimeSpent: 'Sərf olunan vaxt',
    fieldDescription: 'Təsvir',
    fieldResolution: 'Həll',
    noComments: 'Şərh yoxdur',
    noAudit: 'Tarixçə yoxdur',
    writeComment: 'Şərh yazın...',
    attachHint: 'Fayl əlavə et (ən çox 5 ədəd, hərəsi 15 MB)',
    attachTooBig: 'Bəzi fayllar 15 MB-dan böyükdür və əlavə edilmədi',
    attachSending: 'Göndərilir…',
    btnSend: 'Göndər',
  },
  requests: {
    title: 'Müraciətlər',
    departments: 'Şöbələr',
    pageSubtitle: 'Müraciət etmək istədiyiniz şöbəni seçin',
    campusPickSubtitle: 'Əvvəlcə kampusu seçin',
    backToCampuses: 'Kampuslara qayıt',
    detailLabelRequester: 'SİFARİŞÇİ',
    detailLabelAssignee: 'TƏYİN EDİLİB',
    detailLabelDept: 'ŞÖBƏ',
    detailLabelType: 'NÖV',
    detailLabelCreated: 'YARADILDI',
    detailLabelSlaEnd: 'SLA SONU',
    detailTabInfo: 'Məlumat',
    detailTabComments: 'Şərhlər',
    detailTabHistory: 'Tarixçə',
    detailTimeSpent: 'Sərf olunan vaxt:',
    detailDescription: 'Təsvir',
    detailResolution: 'Həll',
    itInfoTitle: 'IT MƏLUMATLARI',
    itCategory: 'KATEQORİYA',
    itRoom: 'SİNİF / OTAQ',
    formRoom: 'Sinif / Otaq',
    formRoomSelect: 'Otağı seçin',
    itDevice: 'CİHAZ',
    itOS: 'OS',
    itError: 'XƏTA',
    formTypeLabel: 'Sorğu növü',
    formTypeSelect: 'Növ seçin',
    formITInfoTitle: 'IT Məlumatları',
    formCategory: 'Kateqoriya',
    formCategorySelect: 'Seçin',
    formDevice: 'Cihaz / Kompüter adı',
    formDevicePlaceholder: 'PC-123 / DELL-ELDAR',
    formOS: 'Əməliyyat sistemi',
    formOSSelect: 'Seçin',
    formErrorMsg: 'Xəta mesajı (varsa)',
    formErrorMsgPlaceholder: 'Xətanın tam mətnini bura yazın...',
    formTitle: 'Başlıq *',
    formTitlePlaceholder: 'Problemin qısa təsviri',
    formDetail: 'Ətraflı təsvir',
    formDetailPlaceholder: 'Problem haqqında ətraflı yazın...',
    formPriority: 'Prioritet',
    slaUrgent: '2 saat',
    slaHigh: '8 saat',
    slaMedium: '24 saat',
    slaLow: '72 saat',
    btnCancel: 'Ləğv et',
    btnSubmit: 'Göndər',
    catEquipment: 'Avadanlıq',
    catSoftware: 'Proqram təminatı',
    catNetwork: 'Şəbəkə',
    catAccess: 'Giriş / İcazə',
    catEmail: 'E-poçt',
    catPrinter: 'Printer',
    catPhone: 'Telefon',
    catOther: 'Digər',
    activeRequestsLabel: 'aktiv sorğu',
    activeRequestsBig: 'AKTİV SORĞU',
    activeSuffix: 'aktiv',
    noActiveRequests: 'sorğu yoxdur',
    employeeSuffix: 'işçi',
    deptSuffix: 'şöbə',
    viewLabel: 'Görünüş',
    viewRows: 'Sıra görünüşü',
    viewTiles: 'Kafel görünüşü',
    colDept: 'Şöbə',
    awaitingRating: 'sorğunuz qiymətləndirmə gözləyir',
    awaitingRatingSub: 'Xidməti qiymətləndirin — sorğu bundan sonra bağlanır',
    requestSuffix: 'sorğu',
    myRequests: 'Mənim sorğularım',
    newRequest: 'Yeni sorğu',
    btnNew: '+ Yeni müraciət',
    btnNewShort: '+ Yeni sorğu',
    requestNumber: 'Nömrə',
    title2: 'Başlıq',
    status: 'Status',
    department: 'Şöbə',
    priority: 'Prioritet',
    priorityFilter: 'Prioritet',
    mineFilter: 'Mənim',
    slaBreached: 'SLA keçdi',
    requester: 'Yaradan',
    assignee: 'Təyin olunmuş',
    createdAt: 'Yaradılma tarixi',
    resolvedAt: 'Həll tarixi',
    timeSpent: 'Sərf olunan vaxt',
    description: 'Təsvir',
    resolution: 'Həll',
    comments: 'Şərhlər',
    history: 'Tarixçə',
    info: 'Məlumat',
    noComments: 'Şərh yoxdur',
    noHistory: 'Tarixçə yoxdur',
    writeComment: 'Şərh yazın...',
    attachHint: 'Fayl əlavə et (ən çox 5 ədəd, hərəsi 15 MB)',
    attachTooBig: 'Bəzi fayllar 15 MB-dan böyükdür və əlavə edilmədi',
    attachSending: 'Göndərilir…',
    noRequests: 'Sorğu tapılmadı',
    noRequestsShort: 'Sorğu yoxdur',
    allStatuses: 'Bütün statuslar',
    allDepartments: 'Bütün şöbələr',
    searchPlaceholder: 'Axtar (nömrə, başlıq)',
    dateFrom: 'Tarixdən',
    dateTo: 'Tarixə qədər',
    priorityHigh: 'Yüksək',
    priorityMedium: 'Orta',
    priorityLow: 'Aşağı',
    priorityUrgent: 'Təcili',
    statusOpen: 'Açıq',
    statusAssigned: 'Təyin edildi',
    statusInProgress: 'İcrada',
    statusPending: 'Gözləmədə',
    statusResolved: 'Həll edildi',
    statusClosed: 'Bağlandı',
    statusCancelled: 'Ləğv edildi',
    deptIT: 'Texniki dəstək, avadanlıq, proqram',
    deptHR: 'Məzuniyyət, arayış, kadr işləri',
    deptFINANCE: 'Əmək haqqı, ödəniş, hesabat',
    deptSUPPLY: 'Anbar tələbnaməsi, alış sifarişi',
    deptADMISSION: 'Şagird qəbulu, sənəd tələbi',
    deptACADEMIC: 'Akademik müraciətlər və sənədlər',
    deptHIK: 'Həmkarlar İttifaqı müraciətləri',
    deptMARKETING: 'Reklam, brendinq, tədbirlər',
    deptMAINTENANCE: 'Təmir, infrastruktur xidməti',
    deptLEGAL: 'Hüquqi məsələlər, müqavilələr və komplayens',
    deptGENERAL: 'Ümumi müraciətlər',
    modalNewTitle: 'Yeni Müraciət',
    modalLeaveTitle: 'İşburaxma Ərizəsi — HR',
    fieldDept: 'Şöbə *',
    selectDept: 'Şöbə seçin',
    fieldLeaveType: 'İşburaxma növü *',
    leaveMedical: 'Tibbi',
    leaveMedicalDesc: 'Xəstəlik vərəqəsi',
    leaveFamily: 'Ailə',
    leaveFamilyDesc: 'Ölüm / Toy',
    leavePersonal: 'Şəxsi',
    leavePersonalDesc: 'İzahat tələb olunur',
    leaveEducation: 'Təhsil',
    leaveEducationDesc: 'Sənəd / izahat',
    leaveOther: 'Digər',
    leaveOtherDesc: 'İzahat tələb olunur',
  },
  status: {
    open: 'Açıq',
    assigned: 'Təyin edildi',
    in_progress: 'İcrada',
    resolved: 'Həll edildi',
    closed: 'Bağlı',
    cancelled: 'Ləğv',
    pending: 'Gözləyir',
    pending_head: 'Rəhbər gözləyir',
    pending_finance: 'Maliyyə gözləyir',
    pending_director: 'Direktor gözləyir',
    approved: 'Təsdiqləndi',
    completed: 'Tamamlandı',
    delivered: 'Təhvil verildi',
  },
  warehouse: {
    importBtn: 'Excel yüklə',
    importTitle: 'Stoku Excel ilə yenilə',
    importHint: 'Anbar balansı faylını seçin. Sistem sütunları özü tanıyır — "1C_Kodu" və "Yekun Balans" olması kifayətdir. Yazmazdan əvvəl nəyin dəyişəcəyini göstərəcək.',
    importPick: 'Faylı seçmək üçün klikləyin (.xlsx)',
    importApply: 'Yenilə',
    importing: 'Gözləyin...',
    importDone: 'Stok yeniləndi',
    importFailed: 'Fayl yüklənmədi',
    mode_update: 'Yalnız yenilə',
    mode_update_desc: 'Fayldakı materialların qalığı yenilənir, digərlərinə toxunulmur',
    mode_replace: 'Tam əvəz et',
    mode_replace_desc: 'Fayldan kənarda qalan materiallar siyahıdan çıxarılır',
    impTotal: 'Fayldakı material',
    impNew: 'Yeni əlavə olunacaq',
    impChanged: 'Miqdarı dəyişəcək',
    impSame: 'Dəyişməyəcək',
    impDeactivated: 'Siyahıdan çıxacaq',
    impErrors: 'Oxunmayan sətir',
    impRow: 'sətir',
    addItemBtn: 'Material əlavə et',
    addItemTitle: 'Anbara material əlavə et',
    addNamePh: 'məs: Kağız bəyaz A4 80qr',
    addHint: 'Bu kod artıq varsa, məlumatları yenilənəcək.',
    itemAdded: 'Material əlavə olundu',
    itemUpdated: 'Material yeniləndi',
    itemFailed: 'Əlavə olunmadı',
    title: 'Anbar',
    subtitle: 'Stok qalığı və tələbnamələrin icrası',
    itemCount: 'material',
    pendingCount: 'icra gözləyir',
    outOfStock: 'qalığı yoxdur',
    tabPending: 'İcra gözləyən',
    tabStock: 'Stok',
    noPending: 'İcra gözləyən tələbnamə yoxdur',
    noItems: 'Material tapılmadı',
    itemsShort: 'məhsul',
    colItem: 'Material',
    colCode: 'Kod',
    colLocation: 'Yer',
    colOnHand: 'Anbarda',
    colRequested: 'İstənilir',
    colIssue: 'Veriləcək',
    colBalance: 'Balans',
    colIssued: 'Verilib',
    colReserved: 'Sifarişdə',
    colAvailable: 'Sərbəst',
    noCode: '(kodsuz)',
    notInCatalog: 'kataloqda yoxdur',
    overStock: 'qalıqdan çoxdur',
    partialHint: 'Miqdarı dəyişərək qismən verə bilərsiniz',
    btnIssue: 'Malı ver',
    issuing: 'Verilir...',
    confirmIssue: 'göstərilən miqdarlar anbardan verilsin?',
    lateTitle: 'Mal gecikib',
    lateDue: 'son tarix',
    lateAsk: 'Mal vermək üçün gecikmə səbəbini yazın:',
    lateTooShort: 'Səbəb ən azı 3 simvol olmalıdır.',
    nothingToIssue: 'Heç bir miqdar göstərilməyib',
    issueFailed: 'Mal verilmədi',
    loadError: 'Məlumat yüklənmədi',
    searchPlaceholder: 'Material, kod və ya rəf üzrə axtar...',
    balanceNote: 'Balans anbarın rəsmi sənədindən götürülüb',
  },
  legal: {
    formNo: 'Forma 1',
    title: 'Mülki-hüquq müqaviləsinin bağlanmasına dair sorğu',
    subtitle: 'Heydər Əliyev adına Müasir Təhsil Kompleksində mülki-hüquq müqavilələrin idarəedilməsi prosedurasına dair',
    sec1: '1. Sorğu göndərən (MTK nümayəndəsi)',
    sec2: '2. Müqavilənin bağlanıldığı digər tərəf',
    sec3: '3. Müqavilənin şərtləri',
    sec4: '4. Təsdiq imzaları',
    fieldRequester: 'Adı, soyadı, atasının adı',
    phRequester: 'məs: Əliyev Elvin Rəşad oğlu',
    fieldPosition: 'Vəzifəsi',
    phPosition: 'məs: Baş mütəxəssis',
    fieldParty: 'Hüquqi və yaxud fiziki şəxsin tam adı',
    phParty: 'məs: "ABC Servis" MMC və ya fiziki şəxsin tam adı',
    fieldContact: 'Müqavilə şərtləri haqqında məlumatlı şəxsin adı, soyadı',
    phContact: 'məs: Hüseynov Kamran',
    fieldPhone: 'Telefon',
    fieldEmail: 'E-poçt',
    fieldSubject: 'Müqavilənin predmeti (xidmət növü)',
    phSubject: 'Hansı iş və ya xidmət göstəriləcək',
    fieldPrice: 'Müqavilə qiyməti və ödəniş şərtləri',
    phPrice: 'Məbləğ və ödəniş qaydası — birdəfəlik, aylıq və s.',
    fieldStart: 'Bağlanma tarixi',
    fieldDuration: 'Müddəti',
    phDuration: 'məs: 12 ay / birdəfəlik xidmət',
    fieldSpecial: 'Müqaviləyə daxil etmək istədiyiniz xüsusi şərt',
    phSpecial: 'Varsa qeyd edin',
    signDirector: 'İcraçı direktor',
    signFinance: 'Baş Maliyyə Rəhbəri',
    signRequester: 'Sorğu göndərən şəxs',
    signNote: 'Təsdiq imzaları çap olunmuş formada atılır. Formanın doldurulma tarixi sorğunun yaradılma tarixidir.',
    errorRequired: 'Qarşı tərəfin adı, müqavilənin predmeti və qiyməti mütləqdir',
    detailTitle: 'Müqavilə sorğusu (Forma 1)',
    flowTitle: 'Təsdiq zənciri',
    stepLawyer: 'Hüquqşünas baxışı',
    stepFinance: 'Baş Maliyyə Rəhbərinin təsdiqi',
    stepDirector: 'İcraçı direktorun təsdiqi',
    stepExecution: 'İcraya başlanılması',
    btnReviewed: 'Baxış keçirildi, göndər',
    btnApprove: 'Təsdiqlə',
    btnExecute: 'İcraya başla',
    btnReject: 'Rədd et',
    rejectReason: 'Rədd səbəbini yazın:',
    rejectedAt: 'Rədd edilib',
    actionFailed: 'Əməliyyat alınmadı',
    btnPrint: 'Formanı çap et',
  },
  procurement: {
    shareBtn: 'Paylaş',
    shareTitle: 'Vəziyyəti e-poçtla paylaş',
    shareDesc: 'Sifarişin cari vəziyyəti və təsdiq zənciri göndəriləcək:',
    shareTo: 'Kimə',
    shareToHint: 'Bir neçə ünvanı vergüllə ayırın (ən çox 10)',
    shareNote: 'Qeyd (istəyə bağlı)',
    shareNotePlaceholder: 'Məs: Salam, sifariş direktor təsdiqini gözləyir',
    shareSend: 'Göndər',
    shareSending: 'Göndərilir...',
    shareSent: 'E-poçt göndərildi',
    shareFailed: 'Göndərilmədi',
    filterActive: 'Aktiv olanlar',
    activeHint: 'Tamamlanmamış və rədd edilməmiş sifarişlər',
    filterAllDepts: 'Bütün şöbələr',
    filterAllTime: 'Bütün vaxtlar',
    period7d: 'Son 7 gün',
    period30d: 'Son 30 gün',
    periodThisMonth: 'Bu ay',
    periodLastMonth: 'Keçən ay',
    period90d: 'Son 3 ay',
    periodThisYear: 'Bu il',
    resultSuffix: 'nəticə',
    clearFilters: 'Filtrləri təmizlə',
    title: 'Təchizat Müraciətləri',
    subtitle: 'Tələbnamə və alış sifarişləri',
    btnNew: 'Yeni müraciət',
    statusPendingHead: 'Şöbə rəhbəri gözləyir',
    statusPendingFinance: 'Maliyyə gözləyir',
    statusPendingDirector: 'Direktor gözləyir',
    statusRejected: 'Rədd edildi',
    purchaseOrder: 'Alış Sifarişi',
    warehouseReq: 'Tələbnamə',
    warehouseReqDesc: 'Anbarda mövcuddur',
    purchaseOrderDesc: 'Satın alma tələb olunur',
    modalNewTitle: 'Yeni Təchizat Müraciəti',
    fieldDept: 'Şöbə *',
    selectDept: 'Şöbə seçin',
    fieldNeededDate: 'Lazım olan tarix *',
    fieldOrderSubject: 'Sifarişin mövzusu *',
    orderSubjectPlaceholder: 'Qısa təsvir (məs: Ofis ləvazimatları sifarişi)',
    fieldProducts: 'Məhsullar *',
    colNum: '№',
    colProductName: 'Malın adı *',
    colProductCode: 'Mal kodu',
    colUnit: 'Ö/V',
    colQty: 'Miqdar',
    colUserUsing: 'İstifadəçi',
    colNote: 'Qeyd',
    colPrice: 'Qiymət',
    colTotal: 'Cəmi',
    productNamePlaceholder: 'Məhsulun tam adı',
    productCodePlaceholder: 'Kod',
    userPlaceholder: 'Ad Soyad',
    notePlaceholder: 'Qeyd',
    addRow: '+ Sətir əlavə et',
    additionalNote: 'Əlavə qeyd',
    additionalNotePlaceholder: 'Əlavə məlumat və ya izahat...',
    cancel: 'Ləğv et',
    submit: 'Göndər',
    timelineCreated: 'Sorğu yaradıldı',
    timelineApproved: 'təsdiqləndi',
    timelineFinanceApproved: 'Büdcə təsdiqi',
    timelineFinalApproval: 'Son təsdiq',
    timelinePurchaseStarted: 'Satın alma başladı',
    timelineDelivered: 'Mal çatdırıldı',
    timelineCompleted: 'Qəbul edildi',
    stageOrderer: 'Sifarişçi',
    stageHead: 'Rəhbər Heyəti',
    stageFinance: 'Maliyyə',
    stageDirector: 'Direktor',
    stagePurchase: 'Alış prosesi',
    stageDelivered: 'Təhvil verildi',
    stageCompleted: 'Tamamlandı',
    waitTime: 'Gözləmə müddəti:',
    daySuffix: 'gün',
    labelOrderer: 'SİFARİŞÇİ',
    labelDept: 'ŞÖBƏ',
    labelCreated: 'YARADILDI',
    labelType: 'NÖV',
    notePrefix: 'Qeyd:',
    grandTotal: 'Ümumi cəm:',
    btnStartAction: 'İcraya başla',
    timerNotStarted: 'Başlamayıb',
    btnDeliverAction: 'Təhvil verildi',
    btnReceiveAction: 'Qəbul et',
    btnRateAction: 'Qiymətləndir',
    btnDownloadPdf: 'PDF Yüklə',
    pdfFailed: 'PDF yaradıla bilmədi',
    uomPiece: 'ədəd',
    uomBundle: 'bağlama',
    uomRoll: 'rulon',
    uomSet: 'dəst',
    uomMeter: 'metr',
    uomKg: 'kq',
    uomLiter: 'litr',
    uomPack: 'paket',
    uomBox: 'qutu',
    uomOther: 'digər',
    overStock: 'Anbar qalığından çoxdur',
    newRequest: 'Yeni sorğu',
    approve: 'Təsdiqlə',
    reject: 'Rədd et',
    orderer: 'Sifarişçi',
    deptHead: 'Şöbə Rəhbəri',
    finance: 'Maliyyə',
    director: 'Direktor',
    warehouse: 'Anbar',
    delivered: 'Təhvil verildi',
    completed: 'Tamamlandı',
    productName: 'Malın adı',
    productCode: 'Mal kodu',
    unit: 'Ö/V',
    quantity: 'Miqdar',
    price: 'Qiymət',
    user: 'İstifadəçi',
    note: 'Qeyd',
    subject: 'Sifarişin mövzusu',
    neededDate: 'Lazım olan tarix',
    additionalNote: 'Əlavə qeyd',
  },
  leave: {
    title: 'İşburaxma Ərizələri',
    newRequest: 'Yeni İşburaxma Ərizəsi',
    btnNew: '+ Ərizə Ver',
    type: 'İşburaxma növü *',
    medical: 'Tibbi',
    medicalDesc: 'Xəstəlik vərəqəsi tələb olunur',
    family: 'Ailə',
    familyDesc: 'Vəfat, toy',
    education: 'Təhsil',
    educationDesc: 'Sənəd və ya izahat',
    other: 'Digər',
    otherDesc: 'İzahat tələb olunur',
    personal: 'Şəxsi',
    startDate: 'Başlama tarixi *',
    endDate: 'Bitmə tarixi *',
    reason: 'Səbəb',
    days: 'gün',
    requestSuffix: 'ərizə',
    pendingSuffix: 'prosesdə',
    countDot: '·',
    allStatuses: 'Bütün statuslar',
    pendingApproval: 'ərizə sizin təsdiqinizi gözləyir',
    inProcess: 'ərizə təsdiq prosesindədir',
    loading: 'Yüklənir...',
    noRequests: 'Ərizə yoxdur',
    waitMgr: 'Gözləyir',
    waitHR: 'HR-də gözləyir',
    waitDir: 'Direktorda gözləyir',
    statusSubmitted: 'Təsdiq Gözləyir',
    statusMgrApproved: 'HR Gözləyir',
    statusMgrRejected: 'Rədd edildi',
    statusHrApproved: 'Direktor Gözləyir',
    statusHrRejected: 'HR rədd etdi',
    statusDirApproved: 'Təsdiqləndi',
    statusDirRejected: 'Rədd Edildi',
    famReasonOwnWedding: 'Özünün toyu',
    famReasonFamilyWedding: 'Ailə üzvünün toyu',
    famReasonFamilyDeath: 'Ailə üzvünün vəfatı',
    famReasonRelativeDeath: 'Yaxın qohumun vəfatı',
    familyReasonLabel: 'Ailə səbəbi *',
    eduDocLabel: 'Müvafiq sənəd varmı?',
    eduDocYes: 'Bəli, sənəd var',
    eduDocNo: 'Xeyr, sənəd yoxdur',
    docUploadLabel: 'Sənədi yükləyin *',
    docUploadHint: 'PDF, şəkil və ya Word. Ən çoxu 3 fayl, hər biri 15 MB-a qədər.',
    docRequiredAlert: 'Sənəd var seçmisiniz — zəhmət olmasa sənədin özünü də əlavə edin.',
    detailDocuments: 'Əlavə olunmuş sənədlər',
    docOpenHint: 'Açmaq / endirmək üçün klikləyin',
    docMissingWarn: 'Sənəd var qeyd olunub, lakin fayl əlavə edilməyib.',
    btnPdf: 'PDF / Çap',
    btnPreview: 'İlkin baxış',
    previewHint: 'Layihə nüsxəsi — rəsmi PDF bütün təsdiqlərdən sonra verilir',
    btnPdfSelected: 'Seçilmişləri PDF',
    pdfPreparing: 'Hazırlanır...',
    selectedCount: 'ərizə seçilib',
    clearSelection: 'Seçimi ləğv et',
    selectForPrint: 'Çap üçün seç',
    selectAll: 'Hamısını seç',
    select: 'Seçin',
    explanation: 'İzahat *',
    explanationNote: 'Qeyd *',
    explanationPlaceholder: 'İşburaxma səbəbini izah edin...',
    btnCancel: 'İmtina',
    btnSubmit: 'Göndər',
    requestNum: 'Ərizə',
    detailEmployee: 'İşçi',
    detailDeptPos: 'Şöbə / Vəzifə',
    detailAbsType: 'İşburaxma növü',
    detailDate: 'Tarix',
    detailExplanation: 'İzahat',
    histStage1: 'Birinci təsdiq',
    histHR: 'HR',
    histDirector: 'Baş Direktor',
    stepSubmitted: 'Göndərildi',
    stepStage1: 'Təsdiq',
    stepHR: 'HR',
    stepDirector: 'Direktor',
    pendingDot: 'Gözləyir',
    mgrTitle: 'Təsdiq Qərarı',
    mgrNoteLabel: 'Qeyd (istəyə bağlı)',
    mgrNotePlaceholder: 'Qeyd əlavə edin...',
    btnReject: 'Rədd et',
    btnApprove: 'Təsdiqlə',
    hrPanelTitle: 'HR Qərarı',
    hrPanelSub: 'İşburaxma növünü və intizam tədbirlərini seçin',
    hrLeaveType: 'İşburaxma növü',
    hrPickFirst: 'Ödənişli və ya ödənişsiz olduğunu seçin — seçim edilməyincə göndərmək olmaz',
    hrPaid: 'Ödənişli',
    hrPaidDesc: 'Əmək haqqı saxlanılır',
    hrUnpaid: 'Ödənişsiz məzuniyyət',
    hrUnpaidDesc: 'Əmək haqqı saxlanılmır',
    hrDiscMeasures: 'İntizam tədbirləri',
    hrDiscEmployee: 'İşçiyə',
    hrDiscManager: 'Rəhbərə',
    hrNote: 'Qeyd',
    hrNotePlaceholder: 'HR qərarı haqqında qeydlərinizi yazın...',
    hrPreviewTitle: 'Direktora göndəriləcək',
    hrPreviewType: 'İşburaxma növü:',
    hrPreviewEmp: 'İşçiyə tədbir:',
    hrPreviewMgr: 'Rəhbərə tədbir:',
    btnSendDirector: 'Direktora Göndər',
    discNone: '— Seçin —',
    discWarning: 'Xəbərdarlıq',
    discSanction: 'İntizam tənbehi',
    discTerminate: 'Əmək müqaviləsinə xitam',
    dirTitle: 'Baş Direktor Qərarı',
    dirHrLabel: 'HR Qərarı:',
    dirPaid: 'Ödənişli işburaxma',
    dirUnpaid: 'Ödənişsiz işburaxma',
    requiredFieldsAlert: 'Bütün məcburi sahələri doldurun',
    badDateAlert: 'Başlama və bitmə tarixi tam yazılmalıdır — gün.ay.il saat:dəqiqə (məs. 02.11.2026 14:20)',
    pastDateAlert: 'Keçmiş tarixə işburaxma ərizəsi vermək olmaz. Başlama tarixi ən tezi bugünkü gün ola bilər (bu gün üçün saatı geri yazmaq mümkündür).',
    endBeforeStartAlert: 'Bitmə tarixi başlama tarixindən əvvəl ola bilməz.',
    genericError: 'Xəta baş verdi',
  },
  newRequest: {
    title: 'Yeni Sorğu',
  },
  enrollment: {
    title: 'Şagird qeydiyyatı üzrə qəbul şöbəsi',
    academicYear: '2025-2026 tədris ili',
    hideHeader: 'Başlığı yığ',
    showHeader: 'Başlığı aç',
    btnAddStudent: '+ Şagird',
    btnTemplate: 'Şablon',
    btnUpload: 'Excel Yüklə',
    btnUploading: 'Yüklənir...',
    sectionTable: 'Qeydiyyat Cədvəli',
    sectionRequests: 'Qəbul Müraciətləri',
    noRequests: 'Müraciət yoxdur',
    colGrade: 'Sinif',
    colAvailable: 'Boş yer',
    colTotal: 'Cəmi',
    grpContinuing: 'Davam edən',
    grpNew: 'Yeni',
    grpTotal: 'Cəmi',
    subExpected: 'Gözlənilən',
    subWithdrawn: 'Çıxan',
    subCurrent: 'Cari',
    subOverall: 'Ümumi',
    subDeposit: 'Depozit',
    subSignedPay: 'İmza × Ödəniş',
    subStaff: 'Staff',
    subMartyr: 'Şəhid',
    rowTotal: 'Cəmi',
    pendingBarText: 'şagirdin sinifi təyin olunmayıb',
    pendingBarOpen: 'Siyahını aç →',
    importedSuffix: 'şagird əlavə edildi',
    moreErrors: 'digər xəta',
    studentSuffix: 'şagird',
    sectionPreschool: 'Pre-school',
    sectionPrimary: 'Primary',
    sectionSecondary: 'Secondary',
    btnNewAdmission: '+ Yeni qəbul müraciəti',
    admColNum: '№',
    admColDate: 'Tarix',
    admColStudent: 'Şagird',
    admColFatherName: 'Ata adı',
    admColCategory: 'Kateqoriya',
    admColGradeAge: 'Sinif/Yaş',
    admColParent: 'Valideyn/Qəyyum',
    admColContract: 'M/N',
    admColContractFull: 'Müqavilə nömrəsi',
    admColSibling: 'Bacı/qardaş',
    admColSiblingFull: 'MTK-da bacı/qardaşı oxuyur?',
    admColParentEmail: 'Valideyn e-poçtu',
    fAdmStudent: 'Şagird adı...',
    fAdmParent: 'Valideyn...',
    sortHint: 'Sıralamaq üçün klikləyin',
    admColPhone: 'Telefon',
    admColStatus: 'Status',
    admColCat: 'Xüsusi status',
    admColCatFull: 'Şəhid övladı, heyət övladı və ya səfirlik',
    admColActions: 'Əməliyyat',
    admColDoc: 'Sənəd',
    admDocNone: 'Sənəd yüklənməyib',
    admDocP1: 'Valideyn 1 — şəxsiyyət vəsiqəsi',
    admDocP2: 'Valideyn 2 — şəxsiyyət vəsiqəsi',
    admDocOpen: 'Şəxsiyyət vəsiqəsinə bax',
    admEmpty: 'Müraciət yoxdur',
    catKindergarten: 'Bağça',
    catLower: 'Aşağı sinif',
    catUpper: 'Yuxarı sinif',
    childStaff: 'Staff',
    childMartyr: 'Şəhid',
    statusPending: 'Gözləyir',
    statusReviewing: 'Baxılır',
    statusAccepted: 'Qəbul edildi',
    statusRejected: 'Rədd edildi',
    statusEnrolled: 'Qeydiyyatlı',
    statusWithdrawn: 'Ayrılıb',
    fKindAll: 'Bütün şagirdlər',
    fKindNew: 'Yeni şagirdlər',
    fKindLegacy: 'Cari şagirdlər',
    countStudents: 'şagird',
    showWithdrawnHint: 'Ayrılmış şagirdləri göstərmək üçün klikləyin',
    noCapacityHint: 'Bu sinif üçün tutum təyin olunmayıb — şagirdlər sayılır, boş yer hesablanmır',
    needsLetterTag: 'hərf təyin olunmayıb',
    needsLetterHint: 'Bu şagirdlərin qrup hərfi seçilməyib — yalnız mərhələ qeyd olunub',
    jumpToSibling: 'sətrinə keçmək üçün klikləyin',
    siblingNotInList: 'Bu şagird siyahıda tapılmadı',
    staffCardHint: 'Əməkdaş haqqında məlumat üçün klikləyin',
    legacyEditFailed: 'Bu şagird üçün qəbul qeydi açıla bilmədi',
    btnAccept: 'Qəbul et',
    btnReject: 'Rədd et',
    btnAcceptedDone: 'Qəbul',
    btnRejectedDone: 'Rədd',
    confirmAccept: 'qəbul edilsin?',
    rejectReasonPrompt: 'Rədd səbəbi:',
    typeContinuing: 'Davam',
    typeNew: 'Yeni',
    detailColLastName: 'Soyadı',
    detailColFirstName: 'Adı',
    detailColFatherName: 'Ata adı',
    detailColType: 'Növ',
    detailColSign: 'İmza',
    detailColSignDate: 'İmza tarixi',
    detailColPayment: 'Ödəniş',
    detailColCat: 'Kateq.',
    detailEmpty: 'Bu sinifdə şagird yoxdur',
    statusActive: 'Aktiv',
    statusOut: 'OUT',
    btnSign: 'İmzala',
    paySigned: 'Signed',
    confirmOut: 'OUT?',
  },
  admission: {
    levelKindergarten: 'Bağça',
    levelKindergartenDesc: '2-6 yaş qrupu',
    levelLower: 'Aşağı sinif',
    levelLowerDesc: '1-5 sinif',
    levelUpper: 'Yuxarı sinif',
    levelUpperDesc: '6-12 sinif',
    fieldAgeGroup: 'Yaş qrupu *',
    fieldClass: 'Sinif *',
    gradeSuffix: '-ci sinif',
    age23: '2-3 yaş — Pre-Nursery',
    age34: '3-4 yaş — Nursery',
    age45: '4-5 yaş — Reception',
    age56: '5-6 yaş — Transition',
    sectionStudent: 'Şagird məlumatları',
    fieldFirstName: 'Adı *',
    fieldLastName: 'Soyadı *',
    fieldFatherName: 'Ata adı *',
    fieldFatherNameOpt: 'Ata adı',
    fieldGender: 'Cinsi *',
    genderSelect: 'Seçin',
    genderMale: 'Kişi',
    genderFemale: 'Qadın',
    fieldBirthDate: 'Doğum tarixi',
    fieldCitizenship: 'Vətəndaşlıq *',
    sectionParent: 'Müqaviləni imzalayan valideyn/qəyyum',
    fieldEmail: 'E-poçt',
    fieldEmailOpt: 'E-poçt',
    sectionAdditional: 'Əlavə məlumatlar',
    typeParent: 'Valideyn',
    typeGuardian: 'Qəyyum',
    fieldDocument: 'Şəxsiyyət vəsiqəsi (şəkil)',
    viewUploadedDoc: 'Yüklənmiş sənədə bax',
    fileTooBig: 'Fayl {mb} MB-dan böyükdür. Daha kiçik şəkil seçin.',
    shrinking: 'Şəkil hazırlanır…',
    fieldPhone: 'Mobil telefon *',
    fieldPhoneOpt: 'Mobil telefon',
    btnAddSecondParent: '+ İkinci valideyn əlavə et',
    secondParent: 'İkinci valideyn',
    btnRemove: 'Sil',
    fieldStatus: 'Status',
    statusRegular: 'Adi',
    statusEmbassy: 'Səfirlik',
    optionOther: 'Digər',
    typeCountry: 'Ölkənin adını yazın',
    fieldAcademicYear: 'Gəldiyi tədris ili',
    fieldGradeSuffix: 'Sinif hərfi (əlavə)',
    fieldGradeSuffixPh: 'məs. A, B və ya (A)',
    gradePreview: 'Nəticə',
    editTitle: 'Müraciətin redaktəsi',
    fieldAddress: 'Ünvan',
    fieldAddressPh: 'Şəhər, rayon, küçə, bina, mənzil',
    fieldContractNo: 'Müqavilə nömrəsi',
    fieldContractNoPh: 'məs. MTK-2026-001',
    statusMartyrChild: 'Şəhid övladı',
    statusStaffChild: 'Heyət övladı',
    fieldStaffParent: 'Hansı əməkdaşın övladıdır?',
    staffParentPlaceholder: 'Əməkdaşın adını yazın…',
    fieldHasSibling: 'MTK-da bacı/qardaşı oxuyur?',
    answerYes: 'Bəli',
    answerNo: 'Xeyr',
    siblingPlaceholder: 'Adı və soyadı',
    sectionPrevSchool: 'Gəldiyi məktəb *',
    schoolUnknown: 'Bilinmir (Bağça)',
    schoolPublic: 'Dövlət məktəbi',
    schoolState: 'Dövlət məktəbi',
    schoolPrivate: 'Özəl məktəb',
    schoolForeign: 'Xarici ölkə',
    fieldSchoolName: 'Məktəbin adı',
    schoolNamePlaceholder: 'Məktəbin tam adı',
    schoolNamePrivate: 'Məktəbin adı',
    fieldCountry: 'Ölkə',
    select: 'Seçin',
    btnCancel: 'Ləğv et',
    btnSubmit: 'Müraciət göndər',
    btnSubmitting: 'Göndərilir...',
    errorSelectGrade: 'Yaş qrupu / sinif seçin',
    errorSelectGender: 'Cinsi seçin',
    errorGeneric: 'Xəta baş verdi',
  },
  timetable: {
    title: 'Cədvəl Tərtibçisi',
    requirements: 'Tələblər',
    availability: 'Müəllim əlçatanlığı',
    rooms: 'Otaqlar',
    autoGenerate: 'Avtomatik tərtib',
    scheduleView: 'Cədvəl baxışı',
    masterGrid: 'Ümumi cədvəl',
    addLesson: '+ Dərs əlavə et',
    class: 'Sinif',
    subject: 'Fənn',
    teacher: 'Müəllim',
    room: 'Otaq',
    hours: 'Saat',
    days: 'Gün',
    total: 'Cəmi',
    group: 'Qrup',
    whole: 'Tam',
    halfA2: 'Yarım (A)',
    halfB2: 'Yarım (B)',
    wholeClass: 'Tam sinif',
    halfA: 'Yarım sinif (A)',
    halfB: 'Yarım sinif (B)',
    divisions: 'Bölmələri idarə et',
    generate: 'Avtomatik tərtib et',
    generateRunning: 'Tərtib olunur…',
    selectAll: 'Hamısını seç',
    clearAll: 'Təmizlə',
    clearExisting: 'Mövcud cədvəli sil',
    placed: 'dərs yerləşdirildi',
    failed: 'yerləşdirilə bilmədi',
    noRequirements: 'Tələb yoxdur',
    dragHint: 'Bütün siniflərin həftəlik cədvəli — sürükləyib köçürün',
    selectTeacher: '— Müəllim seçin —',
    teacherAvailHint: 'Qırmızı = əlçatmaz (həmin saatda dərs keçə bilməz)',
    roomNamePlaceholder: 'Otaq adı (məs: 101, Lab-2)',
    roomKindPlaceholder: 'Növ (lab, zal, adi...)',
    roomCapacityPlaceholder: 'Tutum',
    btnAdd: '+ Əlavə et',
    colName: 'Ad',
    colKind: 'Növ',
    colCapacity: 'Tutum',
    noRooms: 'Otaq yoxdur',
    hoursPerWeek: 'saat/həftə',
    hoursPerLesson: 'saat',
    daysSuffix: 'gün',
    dragLessons: 'Dərsləri sürükləmək olar',
    selectDash: '— Seçin —',
    btnPrint: 'Çap',
    monday: 'Bazar ertəsi',
    tuesday: 'Çərşənbə axşamı',
    wednesday: 'Çərşənbə',
    thursday: 'Cümə axşamı',
    friday: 'Cümə',
    noClasses: 'Sinif yoxdur',
    selectGrade: '— Seçin —',
    addLessonTitle: 'Dərs əlavə et',
    editReq: 'Tələbi redaktə et',
    newReq: 'Yeni tələb',
  },
  chat: {
    sent: 'Göndərildi',
    seen: 'Oxundu',
    title: 'Mesajlar',
    btnNewChat: 'Yeni söhbət',
    btnCreateGroup: 'Qrup yarat',
    noChats: 'Söhbət yoxdur',
    noChatsHint: 'Söhbət yoxdur. Yeni söhbət başladın',
    member: 'üzv',
    statusOnline: 'Onlayn',
    statusOffline: 'Oflayn',
    voiceCall: 'Səsli zəng',
    videoCall: 'Video zəng',
    previousMessages: 'Əvvəlki mesajlar',
    loading: 'Yüklənir...',
    messageDeleted: 'Bu mesaj silindi',
    typing: 'Yazır...',
    messagePlaceholder: 'Mesaj yazın...',
    incomingCall: 'Gələn zəng...',
    calling: 'Zəng edilir...',
    callInProgress: 'Zəng davam edir',
    searchUser: 'İstifadəçi axtar',
    fieldGroupName: 'Qrup adı',
    searchMembers: 'Üzv axtar',
  },
  chatGroup: {
    viewMembers: 'Üzvləri gör',
    addMember: 'Üzv əlavə et',
    addSelected: 'Seçilənləri əlavə et',
    member: 'üzv',
    admin: 'Admin',
    you: 'siz',
    remove: 'Sil',
    leave: 'Çıx',
    confirmRemove: 'Bu üzvü silmək istədiyinə əminsən?',
    removeFailed: 'Silmək alınmadı',
    addFailed: 'Əlavə etmək alınmadı',
    promote: 'Admin et',
    demote: 'Üzv et',
    confirmPromote: 'Bu üzvə admin səlahiyyəti vermək istəyirsiniz?',
    confirmDemote: 'Bu admindən səlahiyyəti silmək istəyirsiniz?',
    roleChangeFailed: 'Rol dəyişmədi',
  },
  menuSetup: {
    title: 'Menyu quraşdırması',
    subtitle: 'Yan panelin görünüşü — rəng, naxış və quruluş',
    reset: 'İlkin halına qaytar',
    colorTitle: 'Menyunun rəngi',
    colorHint: 'Yan panelin əsas rəng çaları',
    patternTitle: 'Fon naxışı',
    patternHint: 'Panelin arxa fonunda incə tor və ya nöqtə',
    layoutTitle: 'Menyunun quruluşu',
    layoutHint: 'Bəndlər siyahı kimi, yoxsa şəbəkə xanaları kimi düzülsün',
    note: 'Bu ayarlar yalnız bu brauzerdə saxlanılır — başqa kompüterdə və ya telefonda açanda yenidən seçmək lazım gələcək.',
  },
  publication: {
    title: 'Nəşr / Çap Sorğusu',
    warning2Days: 'Materialı çap tarixindən ən azı 2 gün əvvəl göndərin. Gec göndərilən materiallar vaxtında çap olunmaya bilər.',
    fieldDate: 'Çap / dərc tarixi *',
    fieldMaterial: 'Material faylları',
    browseHint: 'Faylları yükləmək üçün vurun və ya buraya buraxın',
    formats: 'PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, ZIP — hər fayl ən çoxu 10 MB, 10 fayla qədər',
    addMore: 'Daha fayl əlavə et',
    fileCount: '{n} fayl',
    remove: 'Sil',
    uploading: 'Yüklənir...',
    uploadFailed: 'Fayl yüklənmədi',
    errorTooBig: '«{name}» 10 MB-dan böyükdür ({size} MB) — bu fayl əlavə edilmədi.',
    errorTooMany: 'Ən çoxu 10 fayl əlavə etmək olar.',
    errorBadType: '«{name}» icazəli formatlardan deyil — bu fayl əlavə edilmədi.',
    errorDateRequired: 'Çap tarixini seçin',
    confirmLessThan2Days: 'Çap tarixi 2 gündən azdır. Material vaxtında hazır olmaya bilər. Davam edək?',
    btnDownload: 'Endir',
    btnPreview: 'Bax',
  },
  maintenance: {
    title: 'Təmir İşi Təfərrüatları',
    fieldLocation: 'Bina / Yer',
    fieldLocationPlaceholder: 'Məs: A blok, idarə binası, idman zalı',
    fieldRoom: 'Otaq nömrəsi / mərtəbə',
    fieldRoomPlaceholder: 'Məs: 205, 2-ci mərtəbə',
    fieldAccess: 'Giriş vaxtı',
    accessAnytime: 'İstənilən vaxt',
    accessMorning: 'Səhər (08:00 - 12:00)',
    accessAfternoon: 'Günorta (12:00 - 17:00)',
    accessAfterHours: 'Dərslərdən sonra',
    fieldPhoto: 'Şəkil / sənəd (istəyə bağlı)',
    photoHint: 'Şəkil və ya sənəd əlavə edin',
    photoFormats: 'JPG, PNG, PDF',
    uploading: 'Yüklənir...',
    uploadFailed: 'Şəkil yüklənmədi',
    errorLocation: 'Bina və yer mütləqdir',
    detailLocation: 'Bina / Yer',
    detailRoom: 'Otaq / mərtəbə',
    detailAccess: 'Giriş vaxtı',
    detailPhoto: 'Şəkil / sənəd',
    btnDownload: 'Yüklə',
  },
  finance: {
    info: 'Maliyyə Məlumatları',
    amount: 'Məbləğ (AZN)',
    requestedDate: 'Tələb olunan tarix',
    paymentTerm: 'Ödəmə müddəti',
    subject: 'Müraciətin mövzusu',
    additionalNote: 'Əlavə qeyd',
  },
  login: {
    title: 'Sistemə daxil ol',
    subtitle: 'İstifadəçi adı və şifrənizi daxil edin',
    schoolName: 'Heydər Əliyev adına',
    schoolName2: 'Müasir Təhsil Kompleksi',
    schoolSubtitle: 'Elektron Məktəb Sistemi',
    username: 'İstifadəçi adı',
    password: 'Şifrə',
    submit: 'Daxil ol',
    loading: 'Yüklənir...',
    or: 'və ya',
    microsoft: 'Microsoft 365 ilə daxil ol',
    error: 'İstifadəçi adı və ya şifrə yanlışdır',
    errorGeneric: 'Giriş xətası baş verdi',
  },
  authCallback: {
    checking: 'Microsoft hesabı yoxlanılır...',
    error: 'Giriş xətası',
  },
  analytics: {
    title: 'Analitika',
    subtitle: 'Bütün sistem üzrə statistik xülasə',
    students: 'Tələbələr',
    teachers: 'Müəllimlər',
    classes: 'Siniflər',
    subjects: 'Fənlər',
    totalUsers: 'Bütün istifadəçilər',
    slaCompliance: 'SLA uyğunluğu',
    breached: 'pozulmuş',
    usersByRole: 'Rola görə istifadəçilər',
    enrollmentBySection: 'Səviyyəyə görə qeydiyyat',
    requestsByStatus: 'Statusa görə sorğular',
    requestsByDept: 'Şöbəyə görə sorğular',
    requestsMonthly: 'Aylıq sorğu trendi',
    topPerformers: 'Ən yaxşı performans',
    procurement: 'Təchizat',
    leave: 'İşburaxma',
    gradesDist: 'Qiymət bölgüsü',
    gradesBySubject: 'Fənn üzrə orta qiymət',
    attendance30: 'Son 30 günün davamiyyəti',
    active: 'Aktiv',
    signed: 'İmzalı',
    total: 'Cəmi',
    resolved: 'Həll',
    avg: 'Ort',
    solved: 'həll etdi',
    present: 'İştirak',
    absent: 'İştirak etmir',
    late: 'Gecikmə',
  },
  days: {
    mon: 'Bazar ertəsi',
    tue: 'Çərşənbə axşamı',
    wed: 'Çərşənbə',
    thu: 'Cümə axşamı',
    fri: 'Cümə',
  },
};

export const en = {
  sidebar: {
    dashboard: 'Dashboard',
    themeLabel: 'Colour',
    themeChange: 'Menu colour',
    theme_firuzeyi: 'Teal',
    theme_gece: 'Midnight',
    theme_sherab: 'Wine',
    theme_mese: 'Forest',
    theme_komur: 'Graphite',
    theme_benovseyi: 'Violet',
    theme_buz: 'Ice',
    theme_sedef: 'Pearl',
    patternLabel: 'Pattern',
    patternNone: 'No pattern',
    patternGrid: 'Grid',
    patternDots: 'Dots',
    viewLabel: 'View',
    viewList: 'List',
    viewGrid: 'Grid',
    students: 'Students',
    teachers: 'Teachers',
    classes: 'Classes',
    subjects: 'Subjects',
    attendance: 'Attendance',
    grades: 'Grades',
    timetableBuilder: 'Timetable Builder',
    announcements: 'Announcements',
    requests: 'Departments',
    enrollment: 'Student registration',
    users: 'Users',
    procurement: 'Procurement',
    leave: 'Leave',
    analytics: 'Analytics',
    menuSetup: 'Menu setup',
    warehouse: 'Warehouse',
    groupMain: 'Overview',
    groupAcademic: 'Academic',
    groupAdmission: 'Admissions office',
    groupComm: 'Communication',
    groupSystem: 'System',
  },
  topbar: {
    title: 'School Management System',
    messages: 'Messages',
    myRequests: 'My Requests',
    notifications: 'Notifications',
    readAll: 'Mark all read',
    noNotifications: 'No new notifications',
    newRequestsWaiting: 'new request(s) waiting',
    admissionWaiting: 'admission application(s) pending',
    studentSignWaiting: 'student(s) awaiting signature',
    enrollmentSubmenu: 'Enrollment → Admission Requests',
    enrollmentTable: 'Enrollment Table',
    logout: 'Logout',
    hidePanel: 'Hide top panel',
    showPanel: 'Show top panel',
    changePhoto: 'Change photo',
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    add: 'Add',
    addAction: '+ Add',
    close: 'Close',
    search: 'Search',
    searchPlaceholder: 'Search...',
    filter: 'Filter',
    clear: 'Clear',
    loading: 'Loading...',
    saving: 'Saving...',
    noData: 'No data',
    confirm: 'Confirm',
    confirmDelete: 'Are you sure you want to delete?',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    send: 'Send',
    back: 'Back',
    all: 'All',
    active: 'Active',
    inactive: 'Inactive',
    total: 'Total',
    date: 'Date',
    print: 'Print',
    export: 'Export',
    select: 'Select',
    error: 'Error',
    actions: 'Actions',
    name: 'Name',
    fullName: 'Full Name',
    position: 'Position',
    email: 'Email',
    phone: 'Phone',
    username: 'Username',
    password: 'Password',
    address: 'Address',
    status: 'Status',
    result: 'result',
    results: 'results',
    rowNum: '#',
    notFound: 'Not found',
    deleteConfirm: 'Delete?',
    fileTooLarge: 'Upload error',
    today: 'Today',
  },
  dashboard: {
    welcome: 'Welcome',
    students: 'Students',
    teachers: 'Teachers',
    classes: 'Classes',
    subjects: 'Subjects',
    requests: 'Requests',
    openRequests: 'Open requests',
    todayAttendance: "Today's attendance",
    presentToday: 'Present today',
    absentToday: 'Absent',
    present: 'Present',
    absent: 'Absent',
    late: 'Late',
    excused: 'Excused',
    people: 'people',
    noAttendanceToday: 'No attendance recorded today',
    monthlyRating: 'Monthly Leaderboard',
    byRating: 'By Rating',
    byCount: 'By Count',
    bySpeed: 'By Speed',
    highestRating: 'Highest rated',
    mostTickets: 'Most tickets',
    fastest: 'Fastest',
    avgRating: 'Avg. rating',
    tickets: 'tickets',
    resolved: 'Resolved',
    open: 'Open',
    closed: 'Closed',
    total: 'Total',
    signed: 'Signed',
    pending: 'Pending',
    avgPrefix: 'Avg:',
    noRating: 'No rating',
    loading: 'Loading...',
    noData: 'No data',
    requestsTitle: 'Requests',
    filterAll: 'All',
    filterOpen: 'Open',
    filterAssigned: 'Assigned',
    filterInProgress: 'In progress',
    filterResolved: 'Resolved',
    filterClosed: 'Closed',
    statusOpen: 'Open',
    statusAssigned: 'Assigned',
    statusInProgress: 'In progress',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    noRequestsTitle: 'No requests',
    menuTitle: "Today's menu",
    menuSchool: 'School',
    menuKinder: 'Kindergarten',
    menuUpload: 'Upload menu',
    menuUploading: 'Uploading...',
    menuUploaded: 'Menu uploaded — {gun} days, {yemek} items',
    menuEmpty: 'No menu for today',
    myRequests: 'My Requests',
    viewAll: 'View all',
    noRequests: 'You have no requests yet',
    announcements: 'Recent Announcements',
    noAnnouncements: 'No announcements',
    enrollment: 'Enrollment',
    enrollmentPreschool: 'Pre-school',
    enrollmentPrimary: 'Primary',
    enrollmentSecondary: 'Secondary',
    pendingAdmissionsCount: 'admission application(s) pending',
    pendingSignaturesCount: 'student(s) awaiting signature',
  },
  students: {
    title: 'Students',
    titleEmoji: 'Students',
    countSuffix: 'student(s)',
    btnAdd: '+ Add Student',
    modalNew: 'New Student',
    modalEdit: 'Edit Student',
    colClass: 'Class',
    colFirstName: 'First name',
    colLastName: 'Last name',
    colFatherName: "Father's name",
    genderMale: 'Male',
    genderFemale: 'Female',
    colStudentNumber: 'Student #',
    colParent: 'Parent',
    colParentPhone: 'Parent phone',
    colGender: 'Gender',
    fieldClass: 'Class',
    selectClass: 'Select class',
    fieldStudentNumber: 'Student #',
    fieldParentName: 'Parent name',
    fieldParentPhone: 'Parent phone',
    fieldBirthDate: 'Date of birth',
    fieldGender: 'Gender',
    fieldAddress: 'Address',
    fieldPasswordHint: 'Password (default: school123)',
    fieldPasswordChange: 'Change password',
    fieldPasswordPlaceholder: 'Enter to change',
    genderBoy: 'Boy',
    genderGirl: 'Girl',
    genderBoyEmoji: 'Boy',
    genderGirlEmoji: 'Girl',
    confirmDelete: 'Are you sure you want to delete this student?',
    error: 'An error occurred',
    emptyMsg: 'No student records',
  },
  teachers: {
    title: 'Teachers',
    titleEmoji: 'Teachers',
    countSuffix: 'teacher(s)',
    btnAdd: '+ Add Teacher',
    modalNew: 'New Teacher',
    modalEdit: 'Edit Teacher',
    colSubjects: 'Subjects',
    fieldHireDate: 'Hire date',
    fieldSubjects: 'Subjects taught',
    confirmDelete: 'Are you sure you want to delete this teacher?',
    fieldPasswordChange: 'Change password',
    fieldPasswordPlaceholder: 'Enter to change',
  },
  classes: {
    title: 'Classes',
    studentSuffix: 'student(s)',
    studentNumberCol: '#',
    colLastName: 'Last Name',
    colFirstName: 'First Name',
    colFatherName: "Father's Name",
    colSignature: 'Signature',
    colPayment: 'Payment',
    colCategory: 'Cat.',
    capacity: 'Capacity',
    statusOut: 'OUT',
    statusActive: 'Active',
    signed: 'Signed',
    pending: 'Pending',
    paymentDeposit: 'Deposit',
    paymentAnnual: 'Annual',
    paymentDeposit40: 'Dep+40%',
    childStaff: 'Staff',
    childMartyr: 'Martyr',
    sectionPreschool: 'Pre-school',
    sectionPrimary: 'Primary',
    sectionSecondary: 'Secondary',
    noStudents: 'No students in this class',
  },
  subjects: {
    title: 'Subjects',
    countSuffix: 'subject(s)',
    btnAdd: '+ Add Subject',
    modalNew: 'New Subject',
    modalEdit: 'Edit Subject',
    fieldName: 'Subject name',
    fieldCode: 'Code',
    codePlaceholder: 'e.g. MATH',
  },
  attendance: {
    title: 'Attendance',
    subtitle: 'Daily attendance records by class',
    selectClass: 'Select class',
    fieldClass: 'Class',
    fieldDate: 'Date',
    selectAll: 'Set all:',
    studentSuffix: 'student(s)',
    noStudents: 'No students in this class',
    saved: 'Saved!',
    btnSave: 'Save Attendance',
    statusPresent: 'Present',
    statusAbsent: 'Absent',
    statusLate: 'Late',
    statusExcused: 'Excused',
    overviewTitle: 'Today\'s overview (leave class empty to see all)',
    overviewEmpty: 'No records yet for this date',
    class: 'Class',
  },
  grades: {
    title: 'Grades',
    countSuffix: 'grade(s)',
    btnAdd: '+ Add Grade',
    modalNew: 'Add Grade',
    modalEdit: 'Edit',
    colStudent: 'Student',
    colSubject: 'Subject',
    colType: 'Type',
    colQuarter: 'Qtr',
    colGrade: 'Grade',
    colDate: 'Date',
    fieldStudent: 'Student',
    fieldSubject: 'Subject',
    fieldType: 'Type',
    fieldQuarter: 'Quarter',
    fieldGrade: 'Grade',
    fieldDate: 'Date',
    quarterSuffix: ' qtr',
    allClasses: 'All classes',
    allSubjects: 'All subjects',
    allQuarters: 'All quarters',
    typeExam: 'Exam',
    typeQuiz: 'Quiz',
    typeHomework: 'Homework',
    typeProject: 'Project',
    typeMidterm: 'Midterm',
    typeFinal: 'Final',
    typeQuarter: 'Quarterly',
  },
  schedule: {
    title: 'Class Schedule',
    selectClass: 'Select class',
    selectClassPrompt: 'Select a class to view schedule',
    btnAdd: '+ Add',
    colLesson: 'Lesson',
    fieldSubject: 'Subject',
    fieldTeacher: 'Teacher',
    fieldDay: 'Day',
    fieldLessonNumber: 'Lesson number',
    fieldStart: 'Start',
    fieldEnd: 'End',
    fieldRoom: 'Room',
    roomPrefix: 'Room:',
    btnEditCell: 'Edit',
    btnDeleteCell: 'Delete',
    modalNew: 'Add Lesson',
    modalEdit: 'Edit Lesson',
    lessonSuffix: '. lesson',
  },
  announcements: {
    title: 'Announcements',
    countSuffix: 'announcement(s)',
    btnAdd: '+ Add Announcement',
    modalNew: 'New Announcement',
    modalEdit: 'Edit Announcement',
    fieldTitle: 'Title',
    fieldText: 'Content',
    fieldTarget: 'Target group',
    targetAll: 'Everyone',
    targetStudents: 'Students',
    targetTeachers: 'Teachers',
    targetParents: 'Parents',
    roleAll: 'All',
    roleStudent: 'Student',
    roleTeacher: 'Teacher',
    roleParent: 'Parent',
    btnEdit: 'Edit',
    btnDelete: 'Delete',
    empty: 'No announcements',
  },
  users: {
    fieldManager: 'Direct manager',
    managerHint: 'Leave requests go to this person first. If empty, they go to the department head.',
    managerNone: '— not set —',
    managerSearch: 'Type a name or position...',
    needsSetup: 'New — not configured',
    needsSetupHint: 'Signed in with Microsoft for the first time. Role, position and menu permissions are not set yet.',
    title: 'Users',
    countSuffix: 'user(s)',
    btnAdd: '+ Add User',
    modalNew: 'New User',
    modalEdit: 'Edit User',
    colUser: 'User',
    colPositionDept: 'Position / Department',
    colRole: 'Role',
    fieldRole: 'Role *',
    fieldPosition: 'Position',
    fieldDept: 'Department',
    selectPosition: 'Select position',
    selectDept: 'Select department',
    selectAllDepts: 'All departments',
    customPosOption: 'Other (type manually)',
    customPosPlaceholder: 'Type position name',
    posInputPlaceholder: 'Enter position',
    searchPlaceholder: 'Search by name, username, position...',
    uploadPhoto: 'Upload photo',
    uploadHint: 'JPG, PNG, max 5MB',
    permsTitle: 'Menu permissions',
    btnEdit: 'Edit',
    btnDelete: 'Delete',
    confirmDelete: 'will be deleted?',
    error: 'An error occurred',
    fieldFullName: 'Full Name *',
    fieldUsername: 'Username *',
    fieldPasswordRequired: 'Password *',
    fieldPasswordChange: 'Change password',
    passwordPlaceholder: 'Leave blank to keep',
    roleAdmin: 'Admin',
    roleAdminDesc: 'Full system access',
    roleManagement: 'Management',
    roleManagementDesc: 'Management staff',
    roleStaff: 'Administrative Staff',
    roleStaffDesc: 'Internal staff',
    roleTeacher: 'Teacher',
    roleTeacherDesc: 'Teaching staff',
    roleStudent: 'Student',
    roleStudentDesc: 'Student',
    roleParent: 'Parent',
    roleParentDesc: 'Parent / guardian',
    tabAll: 'All',
    tabStaff: 'Staff',
  },
  myRequests: {
    openInDept: 'Open full details in department',
    title: 'My Requests',
    activeSuffix: 'active',
    totalSuffix: 'total',
    notFound: 'No requests found',
    searchPlaceholder: 'Search (number, title)',
    allStatuses: 'All statuses',
    allDepts: 'All departments',
    dateFrom: 'From date',
    dateTo: 'To date',
    tabInfo: 'Info',
    tabComments: 'Comments',
    tabAudit: 'History',
    fieldStatus: 'Status',
    fieldDept: 'Department',
    fieldPriority: 'Priority',
    fieldRequester: 'Requester',
    fieldAssignee: 'Assignee',
    fieldDate: 'Date',
    fieldResolvedAt: 'Resolved at',
    fieldTimeSpent: 'Time spent',
    fieldDescription: 'Description',
    fieldResolution: 'Resolution',
    noComments: 'No comments',
    noAudit: 'No history',
    writeComment: 'Write a comment...',
    attachHint: 'Attach files (up to 5, 15 MB each)',
    attachTooBig: 'Some files are larger than 15 MB and were skipped',
    attachSending: 'Sending…',
    btnSend: 'Send',
  },
  requests: {
    title: 'Requests',
    departments: 'Departments',
    pageSubtitle: 'Select the department you want to apply to',
    campusPickSubtitle: 'First select a campus',
    backToCampuses: 'Back to campuses',
    detailLabelRequester: 'REQUESTER',
    detailLabelAssignee: 'ASSIGNEE',
    detailLabelDept: 'DEPARTMENT',
    detailLabelType: 'TYPE',
    detailLabelCreated: 'CREATED',
    detailLabelSlaEnd: 'SLA DEADLINE',
    detailTabInfo: 'Info',
    detailTabComments: 'Comments',
    detailTabHistory: 'History',
    detailTimeSpent: 'Time spent:',
    detailDescription: 'Description',
    detailResolution: 'Resolution',
    itInfoTitle: 'IT INFO',
    itCategory: 'CATEGORY',
    itRoom: 'ROOM / CLASS',
    formRoom: 'Room / Classroom',
    formRoomSelect: 'Select room',
    itDevice: 'DEVICE',
    itOS: 'OS',
    itError: 'ERROR',
    formTypeLabel: 'Request type',
    formTypeSelect: 'Select type',
    formITInfoTitle: 'IT Info',
    formCategory: 'Category',
    formCategorySelect: 'Select',
    formDevice: 'Device / computer name',
    formDevicePlaceholder: 'PC-123 / DELL-ELDAR',
    formOS: 'Operating system',
    formOSSelect: 'Select',
    formErrorMsg: 'Error message (if any)',
    formErrorMsgPlaceholder: 'Paste full error text here...',
    formTitle: 'Title *',
    formTitlePlaceholder: 'Short description of the problem',
    formDetail: 'Detailed description',
    formDetailPlaceholder: 'Describe the problem in detail...',
    formPriority: 'Priority',
    slaUrgent: '2 hours',
    slaHigh: '8 hours',
    slaMedium: '24 hours',
    slaLow: '72 hours',
    btnCancel: 'Cancel',
    btnSubmit: 'Submit',
    catEquipment: 'Equipment',
    catSoftware: 'Software',
    catNetwork: 'Network',
    catAccess: 'Access / Permission',
    catEmail: 'Email',
    catPrinter: 'Printer',
    catPhone: 'Phone',
    catOther: 'Other',
    activeRequestsLabel: 'active requests',
    activeRequestsBig: 'ACTIVE REQUESTS',
    activeSuffix: 'active',
    noActiveRequests: 'no requests',
    employeeSuffix: 'staff',
    deptSuffix: 'departments',
    viewLabel: 'View',
    viewRows: 'Row view',
    viewTiles: 'Tile view',
    colDept: 'Department',
    awaitingRating: 'of your requests await a rating',
    awaitingRatingSub: 'Rate the service — the request closes afterwards',
    requestSuffix: 'request(s)',
    myRequests: 'My Requests',
    newRequest: 'New Request',
    btnNew: '+ New Request',
    btnNewShort: '+ New Request',
    requestNumber: 'Number',
    title2: 'Title',
    status: 'Status',
    department: 'Department',
    priority: 'Priority',
    priorityFilter: 'Priority',
    mineFilter: 'Mine',
    slaBreached: 'SLA breached',
    requester: 'Requester',
    assignee: 'Assignee',
    createdAt: 'Created',
    resolvedAt: 'Resolved',
    timeSpent: 'Time spent',
    description: 'Description',
    resolution: 'Resolution',
    comments: 'Comments',
    history: 'History',
    info: 'Info',
    noComments: 'No comments',
    noHistory: 'No history',
    writeComment: 'Write a comment...',
    attachHint: 'Attach files (up to 5, 15 MB each)',
    attachTooBig: 'Some files are larger than 15 MB and were skipped',
    attachSending: 'Sending…',
    noRequests: 'No requests found',
    noRequestsShort: 'No requests',
    allStatuses: 'All statuses',
    allDepartments: 'All departments',
    searchPlaceholder: 'Search (number, title)',
    dateFrom: 'From date',
    dateTo: 'To date',
    priorityHigh: 'High',
    priorityMedium: 'Medium',
    priorityLow: 'Low',
    priorityUrgent: 'Urgent',
    statusOpen: 'Open',
    statusAssigned: 'Assigned',
    statusInProgress: 'In progress',
    statusPending: 'Pending',
    statusResolved: 'Resolved',
    statusClosed: 'Closed',
    statusCancelled: 'Cancelled',
    deptIT: 'Technical support, equipment, software',
    deptHR: 'Leave, certificates, HR matters',
    deptFINANCE: 'Salary, payment, reports',
    deptSUPPLY: 'Warehouse requisition, purchase order',
    deptADMISSION: 'Student admission, document request',
    deptACADEMIC: 'Academic requests and documents',
    deptHIK: 'Trade Union requests',
    deptMARKETING: 'Advertising, branding, events',
    deptMAINTENANCE: 'Repair, infrastructure service',
    deptLEGAL: 'Legal matters, contracts and compliance',
    deptGENERAL: 'General requests',
    modalNewTitle: 'New Request',
    modalLeaveTitle: 'Leave Request — HR',
    fieldDept: 'Department *',
    selectDept: 'Select department',
    fieldLeaveType: 'Leave type *',
    leaveMedical: 'Medical',
    leaveMedicalDesc: 'Sick note',
    leaveFamily: 'Family',
    leaveFamilyDesc: 'Death / Wedding',
    leavePersonal: 'Personal',
    leavePersonalDesc: 'Explanation required',
    leaveEducation: 'Education',
    leaveEducationDesc: 'Document / explanation',
    leaveOther: 'Other',
    leaveOtherDesc: 'Explanation required',
  },
  status: {
    open: 'Open',
    assigned: 'Assigned',
    in_progress: 'In Progress',
    resolved: 'Resolved',
    closed: 'Closed',
    cancelled: 'Cancelled',
    pending: 'Pending',
    pending_head: 'Head Pending',
    pending_finance: 'Finance Pending',
    pending_director: 'Director Pending',
    approved: 'Approved',
    completed: 'Completed',
    delivered: 'Delivered',
  },
  warehouse: {
    importBtn: 'Upload Excel',
    importTitle: 'Update stock from Excel',
    importHint: 'Pick the warehouse balance file. Columns are detected automatically — "1C_Kodu" and "Yekun Balans" are enough. You will see what changes before anything is written.',
    importPick: 'Click to choose a file (.xlsx)',
    importApply: 'Update',
    importing: 'Please wait...',
    importDone: 'Stock updated',
    importFailed: 'Upload failed',
    mode_update: 'Update only',
    mode_update_desc: 'Updates quantities for items in the file, leaves the rest untouched',
    mode_replace: 'Full replace',
    mode_replace_desc: 'Items missing from the file are removed from the list',
    impTotal: 'Items in file',
    impNew: 'Will be added',
    impChanged: 'Quantity will change',
    impSame: 'Unchanged',
    impDeactivated: 'Will be removed',
    impErrors: 'Unreadable rows',
    impRow: 'row',
    addItemBtn: 'Add item',
    addItemTitle: 'Add item to warehouse',
    addNamePh: 'e.g. White paper A4 80gsm',
    addHint: 'If this code already exists, its details will be updated.',
    itemAdded: 'Item added',
    itemUpdated: 'Item updated',
    itemFailed: 'Could not save',
    title: 'Warehouse',
    subtitle: 'Stock levels and requisition fulfilment',
    itemCount: 'items',
    pendingCount: 'awaiting issue',
    outOfStock: 'out of stock',
    tabPending: 'To fulfil',
    tabStock: 'Stock',
    noPending: 'No requisitions awaiting issue',
    noItems: 'No items found',
    itemsShort: 'items',
    colItem: 'Item',
    colCode: 'Code',
    colLocation: 'Location',
    colOnHand: 'On hand',
    colRequested: 'Requested',
    colIssue: 'To issue',
    colBalance: 'Balance',
    colIssued: 'Issued',
    colReserved: 'Reserved',
    colAvailable: 'Available',
    noCode: '(no code)',
    notInCatalog: 'not in catalogue',
    overStock: 'exceeds stock',
    partialHint: 'Adjust quantities to issue partially',
    btnIssue: 'Issue items',
    issuing: 'Issuing...',
    confirmIssue: 'issue the quantities shown?',
    lateTitle: 'Delivery is late',
    lateDue: 'due',
    lateAsk: 'Enter the reason for the delay to issue the items:',
    lateTooShort: 'The reason must be at least 3 characters.',
    nothingToIssue: 'No quantity specified',
    issueFailed: 'Could not issue items',
    loadError: 'Could not load data',
    searchPlaceholder: 'Search by item, code or shelf...',
    balanceNote: 'Balance taken from the official warehouse record',
  },
  legal: {
    formNo: 'Form 1',
    title: 'Request to conclude a civil-law contract',
    subtitle: 'Under the procedure for managing civil-law contracts at Heydar Aliyev Modern Education Complex',
    sec1: '1. Requester (MTK representative)',
    sec2: '2. Counterparty to the contract',
    sec3: '3. Contract terms',
    sec4: '4. Approval signatures',
    fieldRequester: 'Full name (incl. patronymic)',
    phRequester: 'e.g. Aliyev Elvin Rashad oglu',
    fieldPosition: 'Position',
    phPosition: 'e.g. Senior specialist',
    fieldParty: 'Full name of the legal entity or individual',
    phParty: 'e.g. "ABC Service" LLC or full name of the individual',
    fieldContact: 'Contact person familiar with the contract terms',
    phContact: 'e.g. Huseynov Kamran',
    fieldPhone: 'Phone',
    fieldEmail: 'E-mail',
    fieldSubject: 'Subject of the contract (type of service)',
    phSubject: 'What work or service will be provided',
    fieldPrice: 'Contract price and payment terms',
    phPrice: 'Amount and payment schedule — one-off, monthly, etc.',
    fieldStart: 'Start date',
    fieldDuration: 'Duration',
    phDuration: 'e.g. 12 months / one-off service',
    fieldSpecial: 'Special condition to include in the contract',
    phSpecial: 'If any',
    signDirector: 'Executive Director',
    signFinance: 'Chief Financial Officer',
    signRequester: 'Requester',
    signNote: 'Approval signatures are applied on the printed form. The form date is the request creation date.',
    errorRequired: 'Counterparty name, contract subject and price are required',
    detailTitle: 'Contract request (Form 1)',
    flowTitle: 'Approval chain',
    stepLawyer: 'Legal review',
    stepFinance: 'CFO approval',
    stepDirector: 'Executive Director approval',
    stepExecution: 'Execution',
    btnReviewed: 'Reviewed, send on',
    btnApprove: 'Approve',
    btnExecute: 'Start execution',
    btnReject: 'Reject',
    rejectReason: 'Reason for rejection:',
    rejectedAt: 'Rejected at',
    actionFailed: 'Action failed',
    btnPrint: 'Print the form',
  },
  procurement: {
    shareBtn: 'Share',
    shareTitle: 'Share status by email',
    shareDesc: 'The current status and approval chain will be sent for:',
    shareTo: 'To',
    shareToHint: 'Separate several addresses with commas (max 10)',
    shareNote: 'Note (optional)',
    shareNotePlaceholder: 'e.g. Hi, the order is awaiting director approval',
    shareSend: 'Send',
    shareSending: 'Sending...',
    shareSent: 'Email sent',
    shareFailed: 'Could not send',
    filterActive: 'Active only',
    activeHint: 'Orders that are neither completed nor rejected',
    filterAllDepts: 'All departments',
    filterAllTime: 'All time',
    period7d: 'Last 7 days',
    period30d: 'Last 30 days',
    periodThisMonth: 'This month',
    periodLastMonth: 'Last month',
    period90d: 'Last 3 months',
    periodThisYear: 'This year',
    resultSuffix: 'results',
    clearFilters: 'Clear filters',
    title: 'Procurement Requests',
    subtitle: 'Requisitions and purchase orders',
    btnNew: 'New Request',
    statusPendingHead: 'Awaiting Head',
    statusPendingFinance: 'Awaiting Finance',
    statusPendingDirector: 'Awaiting Director',
    statusRejected: 'Rejected',
    purchaseOrder: 'Purchase Order',
    warehouseReq: 'Warehouse Request',
    warehouseReqDesc: 'Available in stock',
    purchaseOrderDesc: 'Procurement required',
    modalNewTitle: 'New Procurement Request',
    fieldDept: 'Department *',
    selectDept: 'Select department',
    fieldNeededDate: 'Needed by *',
    fieldOrderSubject: 'Order subject *',
    orderSubjectPlaceholder: 'Brief description (e.g. Office supplies order)',
    fieldProducts: 'Items *',
    colNum: '#',
    colProductName: 'Item name *',
    colProductCode: 'Item code',
    colUnit: 'Unit',
    colQty: 'Qty',
    colUserUsing: 'User',
    colNote: 'Note',
    colPrice: 'Price',
    colTotal: 'Total',
    productNamePlaceholder: 'Full item name',
    productCodePlaceholder: 'Code',
    userPlaceholder: 'Full name',
    notePlaceholder: 'Note',
    addRow: '+ Add row',
    additionalNote: 'Additional note',
    additionalNotePlaceholder: 'Extra info or explanation...',
    cancel: 'Cancel',
    submit: 'Submit',
    timelineCreated: 'Request created',
    timelineApproved: 'approved',
    timelineFinanceApproved: 'Budget approved',
    timelineFinalApproval: 'Final approval',
    timelinePurchaseStarted: 'Purchase started',
    timelineDelivered: 'Item delivered',
    timelineCompleted: 'Received',
    stageOrderer: 'Orderer',
    stageHead: 'Department Head',
    stageFinance: 'Finance',
    stageDirector: 'Director',
    stagePurchase: 'Purchase process',
    stageDelivered: 'Delivered',
    stageCompleted: 'Completed',
    waitTime: 'Wait time:',
    daySuffix: 'days',
    labelOrderer: 'ORDERER',
    labelDept: 'DEPARTMENT',
    labelCreated: 'CREATED',
    labelType: 'TYPE',
    notePrefix: 'Note:',
    grandTotal: 'Grand total:',
    btnStartAction: 'Start work',
    timerNotStarted: 'Not started',
    btnDeliverAction: 'Mark delivered',
    btnReceiveAction: 'Confirm receipt',
    btnRateAction: 'Rate',
    btnDownloadPdf: 'Download PDF',
    pdfFailed: 'Could not generate PDF',
    uomPiece: 'pcs',
    uomBundle: 'bundle',
    uomRoll: 'roll',
    uomSet: 'set',
    uomMeter: 'meter',
    uomKg: 'kg',
    uomLiter: 'liter',
    uomPack: 'pack',
    uomBox: 'box',
    uomOther: 'other',
    overStock: 'Exceeds warehouse stock',
    newRequest: 'New Request',
    approve: 'Approve',
    reject: 'Reject',
    orderer: 'Orderer',
    deptHead: 'Department Head',
    finance: 'Finance',
    director: 'Director',
    warehouse: 'Warehouse',
    delivered: 'Delivered',
    completed: 'Completed',
    productName: 'Product Name',
    productCode: 'Product Code',
    unit: 'Unit',
    quantity: 'Quantity',
    price: 'Price',
    user: 'User',
    note: 'Note',
    subject: 'Order Subject',
    neededDate: 'Needed By',
    additionalNote: 'Additional Note',
  },
  leave: {
    title: 'Leave Requests',
    newRequest: 'New leave request',
    btnNew: '+ New Request',
    type: 'Leave type *',
    medical: 'Medical',
    medicalDesc: 'Sick note required',
    family: 'Family',
    familyDesc: 'Death, wedding',
    education: 'Education',
    educationDesc: 'Document or explanation',
    other: 'Other',
    otherDesc: 'Explanation required',
    personal: 'Personal',
    startDate: 'Start date *',
    endDate: 'End date *',
    reason: 'Reason',
    days: 'days',
    requestSuffix: 'request(s)',
    pendingSuffix: 'in process',
    countDot: '·',
    allStatuses: 'All statuses',
    pendingApproval: 'request(s) await your approval',
    inProcess: 'request(s) in the approval process',
    loading: 'Loading...',
    noRequests: 'No requests',
    waitMgr: 'Pending',
    waitHR: 'Pending HR',
    waitDir: 'Pending director',
    statusSubmitted: 'Pending Approval',
    statusMgrApproved: 'Pending HR',
    statusMgrRejected: 'Rejected',
    statusHrApproved: 'Pending Director',
    statusHrRejected: 'HR Rejected',
    statusDirApproved: 'Approved',
    statusDirRejected: 'Rejected',
    famReasonOwnWedding: 'Own wedding',
    famReasonFamilyWedding: 'Family wedding',
    famReasonFamilyDeath: 'Family member death',
    famReasonRelativeDeath: 'Relative death',
    familyReasonLabel: 'Family reason *',
    eduDocLabel: 'Do you have supporting document?',
    eduDocYes: 'Yes, document available',
    eduDocNo: 'No, no document',
    docUploadLabel: 'Upload the document *',
    docUploadHint: 'PDF, image or Word. Up to 3 files, 15 MB each.',
    docRequiredAlert: 'You selected "document available" — please attach the document itself.',
    detailDocuments: 'Attached documents',
    docOpenHint: 'Click to open / download',
    docMissingWarn: 'Marked as having a document, but no file was attached.',
    btnPdf: 'PDF / Print',
    btnPreview: 'Preview',
    previewHint: 'Draft copy — the official PDF is issued after all approvals',
    btnPdfSelected: 'Selected as PDF',
    pdfPreparing: 'Preparing...',
    selectedCount: 'request(s) selected',
    clearSelection: 'Clear selection',
    selectForPrint: 'Select for printing',
    selectAll: 'Select all',
    select: 'Select',
    explanation: 'Explanation *',
    explanationNote: 'Note *',
    explanationPlaceholder: 'Describe the reason for leave...',
    btnCancel: 'Cancel',
    btnSubmit: 'Submit',
    requestNum: 'Request',
    detailEmployee: 'Employee',
    detailDeptPos: 'Department / Position',
    detailAbsType: 'Leave type',
    detailDate: 'Date',
    detailExplanation: 'Explanation',
    histStage1: 'First approval',
    histHR: 'HR',
    histDirector: 'Director',
    stepSubmitted: 'Submitted',
    stepStage1: 'Approval',
    stepHR: 'HR',
    stepDirector: 'Director',
    pendingDot: 'Pending',
    mgrTitle: 'Approval Decision',
    mgrNoteLabel: 'Note (optional)',
    mgrNotePlaceholder: 'Add a note...',
    btnReject: 'Reject',
    btnApprove: 'Approve',
    hrPanelTitle: 'HR Decision',
    hrPanelSub: 'Choose leave type and disciplinary action',
    hrLeaveType: 'Leave type',
    hrPickFirst: 'Choose paid or unpaid — you cannot send until one is selected',
    hrPaid: 'Paid',
    hrPaidDesc: 'Salary preserved',
    hrUnpaid: 'Unpaid',
    hrUnpaidDesc: 'Leave without pay',
    hrDiscMeasures: 'Disciplinary measures',
    hrDiscEmployee: 'For employee',
    hrDiscManager: 'For manager',
    hrNote: 'Note',
    hrNotePlaceholder: 'Write your notes about the HR decision...',
    hrPreviewTitle: 'Will be sent to director',
    hrPreviewType: 'Leave type:',
    hrPreviewEmp: 'Employee action:',
    hrPreviewMgr: 'Manager action:',
    btnSendDirector: 'Send to Director',
    discNone: '— Select —',
    discWarning: 'Warning',
    discSanction: 'Disciplinary sanction',
    discTerminate: 'Contract termination',
    dirTitle: 'Director Decision',
    dirHrLabel: 'HR Decision:',
    dirPaid: 'Paid leave',
    dirUnpaid: 'Unpaid leave',
    requiredFieldsAlert: 'Please fill in all required fields',
    badDateAlert: 'Start and end date must be complete — day.month.year hour:minute (e.g. 02.11.2026 14:20)',
    pastDateAlert: 'A leave request cannot be backdated. The start date can be today at the earliest (an earlier hour of today is allowed).',
    endBeforeStartAlert: 'The end date cannot be before the start date.',
    genericError: 'An error occurred',
  },
  newRequest: {
    title: 'New Request',
  },
  enrollment: {
    title: 'Student Registration & Admissions Office',
    academicYear: '2025-2026 Academic Year',
    hideHeader: 'Collapse header',
    showHeader: 'Expand header',
    btnAddStudent: '+ Student',
    btnTemplate: 'Template',
    btnUpload: 'Upload Excel',
    btnUploading: 'Uploading...',
    sectionTable: 'Enrollment Schedule',
    sectionRequests: 'Admission Requests',
    noRequests: 'No requests',
    colGrade: 'Grade',
    colAvailable: 'Available',
    colTotal: 'Total',
    grpContinuing: 'Continuing',
    grpNew: 'New',
    grpTotal: 'Total',
    subExpected: 'Expected',
    subWithdrawn: 'Withdrawn',
    subCurrent: 'Current',
    subOverall: 'Overall',
    subDeposit: 'Deposit',
    subSignedPay: 'Signed × Paid',
    subStaff: 'Staff',
    subMartyr: 'Martyr',
    rowTotal: 'Total',
    pendingBarText: 'student(s) without an assigned class',
    pendingBarOpen: 'Open list →',
    importedSuffix: 'student(s) imported',
    moreErrors: 'more error(s)',
    studentSuffix: 'student(s)',
    sectionPreschool: 'Pre-school',
    sectionPrimary: 'Primary',
    sectionSecondary: 'Secondary',
    btnNewAdmission: '+ New admission request',
    admColNum: '#',
    admColDate: 'Date',
    admColStudent: 'Student',
    admColFatherName: "Father's Name",
    admColCategory: 'Category',
    admColGradeAge: 'Grade / Age',
    admColParent: 'Parent/Guardian',
    admColContract: 'C/N',
    admColContractFull: 'Contract number',
    admColSibling: 'Sibling',
    admColSiblingFull: 'Has a sibling at MTK?',
    admColParentEmail: 'Parent email',
    fAdmStudent: 'Student name...',
    fAdmParent: 'Parent...',
    sortHint: 'Click to sort',
    admColPhone: 'Phone',
    admColStatus: 'Status',
    admColCat: 'Special status',
    admColCatFull: "Martyr's child, staff child or embassy",
    admColActions: 'Actions',
    admColDoc: 'Document',
    admDocNone: 'No document uploaded',
    admDocP1: 'Parent 1 — ID document',
    admDocP2: 'Parent 2 — ID document',
    admDocOpen: 'View ID document',
    admEmpty: 'No requests',
    catKindergarten: 'Preschool',
    catLower: 'Primary',
    catUpper: 'Secondary',
    childStaff: 'Staff',
    childMartyr: 'Martyr',
    statusPending: 'Pending',
    statusReviewing: 'Reviewing',
    statusAccepted: 'Accepted',
    statusRejected: 'Rejected',
    statusEnrolled: 'Enrolled',
    statusWithdrawn: 'Withdrawn',
    fKindAll: 'All students',
    fKindNew: 'New students',
    fKindLegacy: 'Current students',
    countStudents: 'students',
    showWithdrawnHint: 'Click to show withdrawn students',
    noCapacityHint: 'Capacity is not configured for this class — students are counted, free places are not',
    needsLetterTag: 'no letter',
    needsLetterHint: 'These students have no group letter assigned — only the stage is recorded',
    jumpToSibling: 'click to jump to their row',
    siblingNotInList: 'This student was not found in the list',
    staffCardHint: 'Click for staff details',
    legacyEditFailed: 'Could not create an admission record for this student',
    btnAccept: 'Accept',
    btnReject: 'Reject',
    btnAcceptedDone: 'Accepted',
    btnRejectedDone: 'Rejected',
    confirmAccept: 'will be accepted?',
    rejectReasonPrompt: 'Reason for rejection:',
    typeContinuing: 'Cont.',
    typeNew: 'New',
    detailColLastName: 'Last Name',
    detailColFirstName: 'First Name',
    detailColFatherName: "Father's Name",
    detailColType: 'Type',
    detailColSign: 'Signature',
    detailColSignDate: 'Signed on',
    detailColPayment: 'Payment',
    detailColCat: 'Cat.',
    detailEmpty: 'No students in this class',
    statusActive: 'Active',
    statusOut: 'OUT',
    btnSign: 'Sign',
    paySigned: 'Signed',
    confirmOut: 'OUT?',
  },
  admission: {
    levelKindergarten: 'Preschool',
    levelKindergartenDesc: 'Ages 2-6',
    levelLower: 'Primary',
    levelLowerDesc: 'Grades 1-5',
    levelUpper: 'Secondary',
    levelUpperDesc: 'Grades 6-12',
    fieldAgeGroup: 'Age group *',
    fieldClass: 'Grade *',
    gradeSuffix: ' grade',
    age23: '2-3 yrs — Pre-Nursery',
    age34: '3-4 yrs — Nursery',
    age45: '4-5 yrs — Reception',
    age56: '5-6 yrs — Transition',
    sectionStudent: 'Student information',
    fieldFirstName: 'First name *',
    fieldLastName: 'Last name *',
    fieldFatherName: "Father's name *",
    fieldFatherNameOpt: "Father's name",
    fieldGender: 'Gender *',
    genderSelect: 'Select',
    genderMale: 'Male',
    genderFemale: 'Female',
    fieldBirthDate: 'Date of birth',
    fieldCitizenship: 'Citizenship *',
    sectionParent: 'Contract-signing parent/guardian',
    fieldEmail: 'Email',
    fieldEmailOpt: 'Email',
    sectionAdditional: 'Additional information',
    typeParent: 'Parent',
    typeGuardian: 'Guardian',
    fieldDocument: 'ID document (photo)',
    viewUploadedDoc: 'View uploaded document',
    fileTooBig: 'File is larger than {mb} MB. Choose a smaller image.',
    shrinking: 'Preparing image…',
    fieldPhone: 'Mobile phone *',
    fieldPhoneOpt: 'Mobile phone',
    btnAddSecondParent: '+ Add second parent',
    secondParent: 'Second parent',
    btnRemove: 'Remove',
    fieldStatus: 'Status',
    statusRegular: 'Regular',
    statusEmbassy: 'Embassy',
    optionOther: 'Other',
    typeCountry: 'Type the country name',
    fieldAcademicYear: 'Academic year of entry',
    fieldGradeSuffix: 'Class letter (optional)',
    fieldGradeSuffixPh: 'e.g. A, B or (A)',
    gradePreview: 'Result',
    editTitle: 'Edit admission',
    fieldAddress: 'Address',
    fieldAddressPh: 'City, district, street, building, apartment',
    fieldContractNo: 'Contract number',
    fieldContractNoPh: 'e.g. MTK-2026-001',
    statusMartyrChild: "Martyr's child",
    statusStaffChild: 'Staff child',
    fieldStaffParent: 'Which staff member is the parent?',
    staffParentPlaceholder: 'Type the staff member name…',
    fieldHasSibling: 'Has a sibling at MTK?',
    answerYes: 'Yes',
    answerNo: 'No',
    siblingPlaceholder: 'First and last name',
    sectionPrevSchool: 'Previous school *',
    schoolUnknown: 'Unknown (Kindergarten)',
    schoolPublic: 'State school',
    schoolState: 'State school',
    schoolPrivate: 'Private school',
    schoolForeign: 'Foreign country',
    fieldSchoolName: 'School name',
    schoolNamePlaceholder: 'Full school name',
    schoolNamePrivate: 'School name',
    fieldCountry: 'Country',
    select: 'Select',
    btnCancel: 'Cancel',
    btnSubmit: 'Submit application',
    btnSubmitting: 'Submitting...',
    errorSelectGrade: 'Select age group / grade',
    errorSelectGender: 'Select gender',
    errorGeneric: 'An error occurred',
  },
  timetable: {
    title: 'Timetable Builder',
    requirements: 'Requirements',
    availability: 'Teacher Availability',
    rooms: 'Rooms',
    autoGenerate: 'Auto Generate',
    scheduleView: 'Schedule View',
    masterGrid: 'Master Grid',
    addLesson: '+ Add Lesson',
    class: 'Class',
    subject: 'Subject',
    teacher: 'Teacher',
    room: 'Room',
    hours: 'Hours',
    days: 'Days',
    total: 'Total',
    group: 'Group',
    whole: 'Whole',
    halfA2: 'Half (A)',
    halfB2: 'Half (B)',
    wholeClass: 'Whole Class',
    halfA: 'Half Class (A)',
    halfB: 'Half Class (B)',
    divisions: 'Manage Divisions',
    generate: 'Auto Generate',
    generateRunning: 'Generating…',
    selectAll: 'Select All',
    clearAll: 'Clear',
    clearExisting: 'Clear existing schedule',
    placed: 'lesson(s) placed',
    failed: 'could not be placed',
    noRequirements: 'No requirements',
    dragHint: 'Weekly schedule for all classes — drag to move',
    selectTeacher: '— Select teacher —',
    teacherAvailHint: 'Red = unavailable (cannot teach at this hour)',
    roomNamePlaceholder: 'Room name (e.g. 101, Lab-2)',
    roomKindPlaceholder: 'Type (lab, hall, regular...)',
    roomCapacityPlaceholder: 'Capacity',
    btnAdd: '+ Add',
    colName: 'Name',
    colKind: 'Type',
    colCapacity: 'Capacity',
    noRooms: 'No rooms',
    hoursPerWeek: 'hrs/week',
    hoursPerLesson: 'hr',
    daysSuffix: 'days',
    dragLessons: 'Drag lessons to move',
    selectDash: '— Select —',
    btnPrint: 'Print',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    noClasses: 'No classes',
    selectGrade: '— Select —',
    addLessonTitle: 'Add Lesson',
    editReq: 'Edit Requirement',
    newReq: 'New Requirement',
  },
  chat: {
    sent: 'Sent',
    seen: 'Seen',
    title: 'Messages',
    btnNewChat: 'New Chat',
    btnCreateGroup: 'Create Group',
    noChats: 'No chats',
    noChatsHint: 'No chats. Start a new chat',
    member: 'member',
    statusOnline: 'Online',
    statusOffline: 'Offline',
    voiceCall: 'Voice Call',
    videoCall: 'Video Call',
    previousMessages: 'Previous messages',
    loading: 'Loading...',
    messageDeleted: 'This message was deleted',
    typing: 'Typing...',
    messagePlaceholder: 'Write a message...',
    incomingCall: 'Incoming call...',
    calling: 'Calling...',
    callInProgress: 'Call in progress',
    searchUser: 'Search user',
    fieldGroupName: 'Group name',
    searchMembers: 'Search members',
  },
  chatGroup: {
    viewMembers: 'View members',
    addMember: 'Add member',
    addSelected: 'Add selected',
    member: 'member',
    admin: 'Admin',
    you: 'you',
    remove: 'Remove',
    leave: 'Leave',
    confirmRemove: 'Remove this member?',
    removeFailed: 'Failed to remove',
    addFailed: 'Failed to add',
    promote: 'Make admin',
    demote: 'Make member',
    confirmPromote: 'Grant admin rights to this member?',
    confirmDemote: 'Revoke admin rights from this user?',
    roleChangeFailed: 'Failed to change role',
  },
  menuSetup: {
    title: 'Menu setup',
    subtitle: 'Sidebar appearance — colour, pattern and layout',
    reset: 'Reset to defaults',
    colorTitle: 'Menu colour',
    colorHint: 'The main colour shade of the sidebar',
    patternTitle: 'Background pattern',
    patternHint: 'A fine grid or dot texture behind the panel',
    layoutTitle: 'Menu layout',
    layoutHint: 'Show the items as a list or as grid tiles',
    note: 'These settings are stored in this browser only — on another computer or phone you will need to choose again.',
  },
  publication: {
    title: 'Publication / Print Request',
    warning2Days: 'Submit material at least 2 days before the print date. Late submissions may not be printed on time.',
    fieldDate: 'Print / publication date *',
    fieldMaterial: 'Material files',
    browseHint: 'Click or drop files here to upload',
    formats: 'PDF, DOC, DOCX, XLS, XLSX, PNG, JPG, ZIP — max 10 MB each, up to 10 files',
    addMore: 'Add more files',
    fileCount: '{n} file(s)',
    remove: 'Remove',
    uploading: 'Uploading...',
    uploadFailed: 'File upload failed',
    errorTooBig: '“{name}” is larger than 10 MB ({size} MB) — it was not added.',
    errorTooMany: 'You can attach at most 10 files.',
    errorBadType: '“{name}” is not an allowed format — it was not added.',
    errorDateRequired: 'Select a print date',
    confirmLessThan2Days: 'Print date is less than 2 days away. Material may not be ready in time. Continue?',
    btnDownload: 'Download',
    btnPreview: 'Preview',
  },
  maintenance: {
    title: 'Maintenance Job Details',
    fieldLocation: 'Building / Location',
    fieldLocationPlaceholder: 'e.g., Block A, admin building, gym',
    fieldRoom: 'Room number / floor',
    fieldRoomPlaceholder: 'e.g., 205, 2nd floor',
    fieldAccess: 'Access time',
    accessAnytime: 'Anytime',
    accessMorning: 'Morning (08:00 - 12:00)',
    accessAfternoon: 'Afternoon (12:00 - 17:00)',
    accessAfterHours: 'After class hours',
    fieldPhoto: 'Photo / document (optional)',
    photoHint: 'Add a photo or document',
    photoFormats: 'JPG, PNG, PDF',
    uploading: 'Uploading...',
    uploadFailed: 'Photo upload failed',
    errorLocation: 'Building and location are required',
    detailLocation: 'Building / Location',
    detailRoom: 'Room / floor',
    detailAccess: 'Access time',
    detailPhoto: 'Photo / document',
    btnDownload: 'Download',
  },
  finance: {
    info: 'Finance Information',
    amount: 'Amount (AZN)',
    requestedDate: 'Requested Date',
    paymentTerm: 'Payment Term',
    subject: 'Request Subject',
    additionalNote: 'Additional Note',
  },
  login: {
    title: 'Sign in',
    subtitle: 'Enter your username and password',
    schoolName: 'Heydar Aliyev',
    schoolName2: 'Modern Education Complex',
    schoolSubtitle: 'Electronic School System',
    username: 'Username',
    password: 'Password',
    submit: 'Sign in',
    loading: 'Loading...',
    or: 'or',
    microsoft: 'Sign in with Microsoft 365',
    error: 'Invalid username or password',
    errorGeneric: 'Sign in error occurred',
  },
  authCallback: {
    checking: 'Verifying Microsoft account...',
    error: 'Login error',
  },
  subjectNames: {
    'Azərbaycan dili': 'Azerbaijani',
    'Bədən tərbiyəsi': 'Physical Education',
    'Biologiya': 'Biology',
    'Coğrafiya': 'Geography',
    'Ədəbiyyat': 'Literature',
    'Fizika': 'Physics',
    'İnformatika': 'Computer Science',
    'İngilis dili': 'English',
    'Kimya': 'Chemistry',
    'Musiqi': 'Music',
    'Rəsm': 'Art',
    'Riyaziyyat': 'Mathematics',
    'Rus dili': 'Russian',
    'Tarix': 'History',
  },
  positions: {
    'Anbar koordinatoru': 'Stock Coordinator',
    'Baş maliyyə rəhbəri': 'Chief Financial Officer (CFO)',
    'Baş qrafik və animasiya dizayneri, video redaktor': 'Senior Graphic and Animation Designer, Video Editor',
    'Böyük mühasib': 'Senior Accountant',
    'Dayə': 'Nanny',
    'Dülgər': 'Carpenter',
    'Fotoqraf və videoqraf': 'Photographer and Videographer',
    'Gözətçi': 'Guard',
    'Gözətçilərin koordinatoru': 'Guard Coordinator',
    'Həkim': 'Doctor',
    'Hovuz xidmətçisi': 'Pool Attendant',
    'Hüquq və hüquqi komplayens üzrə mütəxəssis': 'Law and Legal Compliance Specialist',
    'İbtidai sinif müəllimi': 'Primary School Teacher',
    'İbtidai siniflər üzrə kitabxanaçı': 'Primary School Librarian',
    'İbtidai təhsil pilləsi üzrə lider': 'Primary Stage Leader',
    'İngilis dili üzrə tərbiyəçi': 'Preschool Homeroom Teacher',
    'İngilis dili üzrə tərbiyəçi assistenti': 'Preschool Team Teacher',
    'İnnovasiyalar üzrə koordinator': 'Innovation Coordinator',
    'İnsan resursları üzrə generalist': 'HR Generalist',
    'İnsan resursları şöbəsinin meneceri': 'HR Manager',
    'İşə qəbul üzrə mütəxəssis': 'Recruitment Specialist',
    'İstismar və texniki təminat üzrə koordinator': 'Facilities Maintenance Coordinator',
    'İT koordinator': 'IT Coordinator',
    'IT Mütəxəssisi': 'IT Specialist',
    'Sistem Administratoru': 'System Administrator',
    'Şəbəkə Mühəndisi': 'Network Engineer',
    'Kafeteriya üzrə xidmət işçisi': 'Cafeteria Service Worker',
    'Kamera müşahidə operatoru': 'CCTV Operator',
    'Katiblik şöbəsinin koordinatoru': 'Coordinator of Secretariat',
    'Katiblik şöbəsinin mütəxəssisi, qeydiyyatçı': 'Secretariat Specialist, Receptionist',
    'Kitabxana koordinatoru': 'Library Coordinator',
    'Kitabxana operatoru': 'Library Operator',
    'Klublar üzrə koordinator': 'Clubs Coordinator',
    'Kompleksin İcraçı direktoru': 'Executive Director',
    'Koordinator': 'Coordinator',
    'Laborant': 'Laboratory Technician',
    'Maliyyə nəzarətçisi': 'Financial Controller',
    'Marketinq şöbəsinin koordinatoru': 'Marketing Coordinator',
    'Məktəb direktoru': 'School Principal',
    'Məktəb direktorunun milli kurikulum üzrə müavini': 'Deputy Principal for the National Curriculum',
    'Məktəb Direktorunun Şəxsi Köməkçi': 'Personal Assistant to the School Principal',
    'Məktəbəqədər təhsil pilləsi üzrə lider': 'Preschool Stage Leader',
    'Məşqçi': 'Trainer',
    'Müəllim': 'Teacher',
    'Müəllim assistenti': 'Primary Team Teacher',
    'Mühasib': 'Accountant',
    'Nəşr işləri üzrə mütəxəssis': 'Publication Specialist',
    'Növbə rəisi': 'Duty Chief',
    'Orta təhsil pilləsi üzrə lider': 'Middle School Stage Leader',
    'PR və layihələr üzrə koordinator': 'PR and Projects Coordinator',
    'Psixoloq': 'Student Counsellor',
    'Qazanxana növbətçisi': 'Boiler Operator',
    'Referent': 'Administrative Assistant (Music School)',
    'Rəssam tərtibatçı': 'Art Designer',
    'Şagird qəbulu şöbəsinin koordinatoru': 'Admissions Coordinator',
    'Şagirdlərin qəbulu üzrə mütəxəssis': 'Admissions Specialist',
    'Santexnik': 'Plumber',
    'Satış və inzibati xidmətlər üzrə mütəxəssis': 'Sales and Administrative Services Specialist',
    'SƏTƏM üzrə mütəxəssis': 'HSE Specialist',
    'Sinif rəhbəri, Ali təhsil üzrə məsləhətçi': 'Homeroom Teacher, University Counsellor',
    'SMM, reels maker': 'SMM, Reels Maker',
    'Su hovuzu və idman qurğuları üzrə mexanik': 'Swimming Pool and Sports Facilities Mechanic',
    'Sürücü': 'Driver',
    'Təchizat üzrə koordinator': 'Procurement Coordinator',
    'Təchizat üzrə mütəxəssis': 'Procurement Specialist',
    'Təhsil məsələləri üzrə məsləhətçi': 'Consultant on Educational Issues',
    'Təhsil strategiyaları üzrə konsultant': 'Consultant on Education Strategies',
    'Təhsilin inkişafı üzrə məktəb direktorunun müavini': 'Deputy Principal for Educational Development',
    'Təmizlik üzrə nəzarətçi': 'Cleaning Supervisor',
    'Təmizlik üzrə xidmətçi': 'School Cleaner',
    'Texniki işçi': 'Technical Worker',
    'Texniki problemlər üzrə mütəxəssis': 'IT Support Specialist / Help Desk Specialist',
    'Tibb bacısı': 'Nurse',
    'Tikiş sexinin operatoru': 'Sewing Shop Operator',
    'Yuxarı təhsil pilləsi üzrə lider': 'High School Stage Leader',
    'Digər': 'Other',
  },
  roles: {
    admin: 'Admin',
    department_head: 'Management',
    staff: 'Administrative Staff',
    teacher: 'Teacher',
    ibtidai_sinif_muellimi: 'Primary School Teacher',
    student: 'Student',
    parent: 'Parent',
  },
  departments: {
    'İnsan Resursları': 'Human Resources',
    'İnformasiya Texnologiyaları': 'Information Technology',
    'Maliyyə': 'Finance',
    'Qəbul Şöbəsi': 'Admissions',
    'Təchizat': 'Procurement',
    'Akademik': 'Academic',
    'Həmkarlar İttifaqı Komitəsi': 'Trade Union Committee',
    'Ümumi Kompleks': 'General Complex',
    'Marketinq': 'Marketing',
    'İstismar və Texniki Təminat': 'Facilities Maintenance',
    'Anbar': 'Warehouse',
    'Hüquq və Komplayens / Mərkəzi Aparat': 'Legal & Compliance / Central Office',
  },
  analytics: {
    title: 'Analytics',
    subtitle: 'System-wide statistical overview',
    students: 'Students',
    teachers: 'Teachers',
    classes: 'Classes',
    subjects: 'Subjects',
    totalUsers: 'Total users',
    slaCompliance: 'SLA compliance',
    breached: 'breached',
    usersByRole: 'Users by role',
    enrollmentBySection: 'Enrollment by section',
    requestsByStatus: 'Requests by status',
    requestsByDept: 'Requests by department',
    requestsMonthly: 'Monthly request trend',
    topPerformers: 'Top performers',
    procurement: 'Procurement',
    leave: 'Leave',
    gradesDist: 'Grade distribution',
    gradesBySubject: 'Average by subject',
    attendance30: 'Last 30 days attendance',
    active: 'Active',
    signed: 'Signed',
    total: 'Total',
    resolved: 'Resolved',
    avg: 'Avg',
    solved: 'solved',
    present: 'Present',
    absent: 'Absent',
    late: 'Late',
  },
  days: {
    mon: 'Monday',
    tue: 'Tuesday',
    wed: 'Wednesday',
    thu: 'Thursday',
    fri: 'Friday',
  },
};
